var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleCore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 85,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 28v1h-1v-1zm-24 8v-1h1v1zm-2 16h-1v-1h1zm7 29v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1zm-3 26h-1v-1h1zm8 24h-1v-1h1zM17 93h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58h1v1h-1zm9 32v-1h1v1zm-7 1v-1h1v1zm-5 0h1v1h-1z",
    fill: "#fddbaa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 29h-2v-1h2zm27 61h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1zM14 39h1v1h-1zm40 22v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v1h-1v-1zm-32 8h-1v-1h1zm-1 1v1h-1v-1z",
    fill: "#fee9c2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91v-2h1v2zm22-11h1v1h-1z",
    fill: "#fcd9a0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-1v-1zm3 2v1h-1v-1zM29 95h-1v-1h1z",
    fill: "#fee1b5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1zm-33 9h1v1h-1zm9 4v1h-1v-1z",
    fill: "#fddaac"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31v1h-1v-1zM24 42h-1v-1h1z",
    fill: "#b83441"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1zm-2 4v1h-1v-1z",
    fill: "#ccc",
    fillOpacity: 0.02
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h2v1h-1z",
    fill: "#efc180"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54h-1v-1h1zm11 33h-1v-1h1z",
    fill: "#fbd5a3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54h1v1h-1zm11 2v-1h1v1z",
    fill: "#f6d4a8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55h-1v-1h2v1z",
    fill: "#f6ce98"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h1v1h-1zm-34 4h-1v-1h1z",
    fill: "#aff",
    fillOpacity: 0.012
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v1h-1v-1zm-4 44v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.02
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h-1v-1h1zm-7 31v-1h1v1z",
    fill: "#fee2b9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h1v1h-1zm9 35v1h-1v-1z",
    fill: "#f7d1a0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57v-1h1v1zm-4 0h1v1h-1z",
    fill: "#f5d2a2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v1h-1v-1zm-10 1h1v1h-1z",
    fill: "#f4d09e"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h-1v-1h1zm3 27v-1h1v1z",
    fill: "#ffe4c2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28 58h-1v-1h1zm29 22v1h-1v-1z",
    fill: "#ffebc3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1zm0 3h-1v-1h1z",
    fill: "#f7d19e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57h1v1h-1zm-5 3v1h-1v-1z",
    fill: "#f5cf97"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58h1v1h-1zm19 34v-1h1v1z",
    fill: "#f7d6a9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38 59v-1h2v1h-1z",
    fill: "#f7d5a9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58v1h-1v-1zm2 30h1v1h-1z",
    fill: "#f1ca81"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1zm5 36h-1v-1h1z",
    fill: "#f7d4a2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32 59h1v1h-1zm31 26v-1h1v1z",
    fill: "#fcdcaf"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59v1h-1v-1zm29 27v1h-1v-1z",
    fill: "#fee2bd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h1v1h-1zm15 32h1v1h-1z",
    fill: "#f8d4a2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60h-1v-1h1zm2-1h1v1h-1z",
    fill: "#f6d29d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1zm3 33h-1v-1h1z",
    fill: "#f3cb8e"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59h1v1h-1zm-7 34h-1v-1h1z",
    fill: "#fbd194"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61v-1h1v1zm8 31h-1v-1h1z",
    fill: "#fddda7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61v-1h1v1zm23 19h-1v-1h1z",
    fill: "#fcd58f"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60h1v1h-1zm20 29h-1v-1h1z",
    fill: "#f7d195"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62h-1v-1h1zm-1 28h1v1h-1z",
    fill: "#fedba1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1zm-3 2v1h-1v-1z",
    fill: "#f2c46c"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65v-1h1v1zm0 12v1h-1v-1z",
    fill: "#ffebd7",
    fillOpacity: 0.051
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65h1v1h-1zm8 12h-1v-1h1z",
    fill: "#e6ba33"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M55 77v1h-1v-1zM31 87v-1h1v1z",
    fill: "#fedfae"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43 80v-1h1v1zm2 5v1h-1v-1z",
    fill: "#f8d598"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79h1v1h-1zM38 89h1v1h-1z",
    fill: "#fedeac"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-1v-1h1zm-13 5h-1v-1h1z",
    fill: "#fde2b8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h-1v-1h1zm-5 5h-1v-1h1z",
    fill: "#fee9bf"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h1zM38 94h-1v-1h1z",
    fill: "#fde0b6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82v-1h1v1zm-32 8v-1h1v1z",
    fill: "#fee3b9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1zm-38 8h-1v-1h1z",
    fill: "#fee8c6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v1h-1v-1zm-1 4v-1h1v1z",
    fill: "#fde2b9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82h1v1h-1zm-18 9h-1v-1h1z",
    fill: "#fee4c0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84h-1v-1h1zm39 3v-1h1v1z",
    fill: "#fad8aa"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M44 84h-1v-1h1zm9 4v-1h1v1z",
    fill: "#f4d496"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28 86h-1v-2h1v1z",
    fill: "#feefd0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84h1v1h-1zm16 3h1v1h-1z",
    fill: "#f7d189"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M59 85h-1v-1h1zm-17 2v1h-1v-1z",
    fill: "#fde2bb"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86v-1h1v1zm5 0v-1h1v1z",
    fill: "#feecca"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M55 85h1v1h-1zm1 6h-1v-1h1z",
    fill: "#f9d8ac"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M61 86h-1v-1h1zm-39 5v-1h1v1z",
    fill: "#fee3bc"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86h-1v-1h1zm-45 7v-1h1v1z",
    fill: "#fcd9ab"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M22 86h1v1h-1zm6 2v1h-1v-1z",
    fill: "#fee9c5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1zm-3 6v-1h1v1z",
    fill: "#fce0b8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60 88v-1h1v1zm-38 5h-1v-1h1z",
    fill: "#fddcb2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M34 88v1h-1v-1zm0 8v1h-1v-1z",
    fill: "#fbd396"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89h-1v-1h1zm-13 8v-1h1v1z",
    fill: "#fedfb4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h1v1h-1zm0 1v1h-1v-1z",
    fill: "#efc983"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M24 89v1h-1v-1zm11 5h-1v-1h1z",
    fill: "#fee4b9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M29 89h1v1h-1zm8 2v1h-1v-1z",
    fill: "#fedca8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M65 89v1h-1v-1zm-34 9h-1v-1h1z",
    fill: "#fbd39e"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90h1v1h-1zm-13 2h-1v-1h1z",
    fill: "#fddfb6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M25 91v1h-2v-1h1z",
    fill: "#fedcac"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M30 93h-1v-1h1zm6 1v1h-1v-1z",
    fill: "#fddbac"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94h-1v-1h1zm1-1h1v1h-1z",
    fill: "#feddab"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95h1v1h-1zm2 1v-1h1v1z",
    fill: "#f8ce9d"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30h-1v-1h1z",
    fill: "#ffe1e1",
    fillOpacity: 0.067
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v1h-1v-1z",
    fill: "#e8b2b2",
    fillOpacity: 0.224
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29v1h-1v-1z",
    fill: "#e8aaaf",
    fillOpacity: 0.4
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30h-1v-1h1z",
    fill: "#dd9a98",
    fillOpacity: 0.565
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30h-1v-1h1z",
    fill: "#da8d8b",
    fillOpacity: 0.686
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30v-1h1v1z",
    fill: "#dc8b8f",
    fillOpacity: 0.761
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30v-1h1v1z",
    fill: "#df8a8c",
    fillOpacity: 0.804
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30h-1v-1h1z",
    fill: "#dd8688",
    fillOpacity: 0.804
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30v-1h1v1z",
    fill: "#dc8386",
    fillOpacity: 0.788
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h-1v-1h1z",
    fill: "#e18d90",
    fillOpacity: 0.757
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v-1z",
    fill: "#e39598",
    fillOpacity: 0.702
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30v-1h1v1z",
    fill: "#e09c9c",
    fillOpacity: 0.627
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#e3a2a0",
    fillOpacity: 0.553
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#df9d9b",
    fillOpacity: 0.471
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1z",
    fill: "#d79b99",
    fillOpacity: 0.353
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#dda8a5",
    fillOpacity: 0.267
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30h-1v-1h1z",
    fill: "#dfc0c0",
    fillOpacity: 0.192
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1z",
    fill: "#f3e7e7",
    fillOpacity: 0.086
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h-1v-1h1z",
    fill: "#f0c3c3",
    fillOpacity: 0.133
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30v1h-1v-1z",
    fill: "#dfa5a7",
    fillOpacity: 0.412
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M33 31v-1h1v1z",
    fill: "#da9498",
    fillOpacity: 0.682
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h1v1h-1z",
    fill: "#d78480",
    fillOpacity: 0.886
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31h-1v-1h1z",
    fill: "#d27373",
    fillOpacity: 0.996
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31v-1h1v1z",
    fill: "#d66771"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30v1h-1v-1z",
    fill: "#d15a62"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31h-1v-1h1z",
    fill: "#ce505a"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31h-1v-1h1z",
    fill: "#cf4a56"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30h1v1h-1z",
    fill: "#cc4b54"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M41 31v-1h1v1z",
    fill: "#cd4a51"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30v1h-1v-1z",
    fill: "#cf4b52"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M43 31v-1h1v1z",
    fill: "#cf4d55"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h1v1h-1z",
    fill: "#cf5058"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31h-1v-1h1z",
    fill: "#d45c63"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31v-1h1v1z",
    fill: "#db6a70"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#d8696f"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h1v1h-1z",
    fill: "#d67274"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31h-1v-1h1z",
    fill: "#d27b7f"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31h-1v-1h1z",
    fill: "#d18085",
    fillOpacity: 0.988
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1z",
    fill: "#d18687",
    fillOpacity: 0.91
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#cc8485",
    fillOpacity: 0.816
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#d49294",
    fillOpacity: 0.725
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-1z",
    fill: "#d9a4a4",
    fillOpacity: 0.561
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31v-1h1v1z",
    fill: "#d5aeae",
    fillOpacity: 0.333
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#d5baba",
    fillOpacity: 0.145
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M29 32h-1v-1h1z",
    fill: "#ebebeb",
    fillOpacity: 0.051
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31v1h-1v-1z",
    fill: "#e0adad",
    fillOpacity: 0.329
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32h-1v-1h1z",
    fill: "#de9194",
    fillOpacity: 0.678
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31v1h-1v-1z",
    fill: "#d77a7e",
    fillOpacity: 0.941
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h1v1h-1z",
    fill: "#ce6a6d"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v-1h1v1z",
    fill: "#c8575c"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31h1v1h-1z",
    fill: "#bf474f"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32v-1h1v1z",
    fill: "#be444e"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32h-1v-1h1z",
    fill: "#b73140"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31v1h-1v-1z",
    fill: "#b42b3c"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31v1h-1v-1z",
    fill: "#b62b3c"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31v1h-1v-1z",
    fill: "#ba2a3d"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32h-1v-1h1z",
    fill: "#bc2d3f"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32h-1v-1h1z",
    fill: "#bf2f40"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31h1v1h-1z",
    fill: "#b92c3f"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M44 31v1h-1v-1z",
    fill: "#ba3041"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31v1h-1v-1z",
    fill: "#be3141"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-1v-1h1z",
    fill: "#be3444"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32h-1v-1h1z",
    fill: "#c5424a"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M49 31v1h-1v-1z",
    fill: "#c2454d"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31v1h-1v-1z",
    fill: "#b9454e"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32h-1v-1h1z",
    fill: "#b84b51"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#be5458"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#c15d62"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#c5686b"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1z",
    fill: "#d48284"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32h-1v-1h1z",
    fill: "#d89899"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#d8a2a3",
    fillOpacity: 0.953
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#deabae",
    fillOpacity: 0.78
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M59 32h-1v-1h1z",
    fill: "#e0b8ba",
    fillOpacity: 0.494
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31h1v1h-1z",
    fill: "#dabbbb",
    fillOpacity: 0.192
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33v-1h1v1z",
    fill: "#eee",
    fillOpacity: 0.059
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M27 32h1v1h-1z",
    fill: "#e8c0c0",
    fillOpacity: 0.435
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32h1v1h-1z",
    fill: "#e09e9e",
    fillOpacity: 0.839
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33h-1v-1h1z",
    fill: "#d78180"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32v1h-1v-1z",
    fill: "#d0656b"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32v1h-1v-1z",
    fill: "#c14e54"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v1h-1v-1z",
    fill: "#b43947"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32h1v1h-1z",
    fill: "#bb3849"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-1h1v1z",
    fill: "#b83749"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32h1v1h-1z",
    fill: "#ad2c40"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h-1v-1h1z",
    fill: "#b12238"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33v-1h1v1z",
    fill: "#a9172c"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32h1v1h-1z",
    fill: "#aa172c"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33h-1v-1h1z",
    fill: "#ac152c"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32v1h-1v-1z",
    fill: "#b1172a"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32v1h-1v-1z",
    fill: "#b8192c"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-1v-1z",
    fill: "#b51c2f"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32v1h-1v-1z",
    fill: "#b31f33"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33v-1h1v1z",
    fill: "#c0293c"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#bb2a3c"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1z",
    fill: "#b62f41"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1z",
    fill: "#b22e3b"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1z",
    fill: "#ad2d3a"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1z",
    fill: "#aa323c"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#ae3842"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#b7434b"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1z",
    fill: "#b2454d"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#a4404a"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#a84450"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#ba5d66"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1z",
    fill: "#ca7a7e"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#d79194"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33v-1h1v1z",
    fill: "#e1a6a7"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#dfacae",
    fillOpacity: 0.973
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1z",
    fill: "#e0b6b7",
    fillOpacity: 0.686
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1z",
    fill: "#e1c0c4",
    fillOpacity: 0.239
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.067
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33h1v1h-1z",
    fill: "#eecfcf",
    fillOpacity: 0.357
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33h1v1h-1z",
    fill: "#e6c1be",
    fillOpacity: 0.831
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h-1v-1h1z",
    fill: "#e7ada9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34v-1h1v1z",
    fill: "#d88585"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33h1v1h-1z",
    fill: "#c66064"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33v1h-1v-1z",
    fill: "#b5444b"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h-1v-1h1z",
    fill: "#b0323d"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33v1h-1v-1z",
    fill: "#b23042"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34v-1h1v1z",
    fill: "#ac273d"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1z",
    fill: "#af263a"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-1h1v1z",
    fill: "#a7182d"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#a81328"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#a91325"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#a81124"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33h1v1h-1z",
    fill: "#a50e1f"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34v-1h1v1z",
    fill: "#ac151e"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34h-1v-1h1z",
    fill: "#b6191e"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34h-1v-1h1z",
    fill: "#b2161e"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M43 33h1v1h-1z",
    fill: "#ab0c1c"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1z",
    fill: "#b11323"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33h1v1h-1z",
    fill: "#b21b2d"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1z",
    fill: "#b22032"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#ae3539"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1z",
    fill: "#a4463c"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#9f3431"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#9e3435"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1z",
    fill: "#a83140"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1z",
    fill: "#9c2e40"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1z",
    fill: "#942c40"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1z",
    fill: "#9c3043"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1z",
    fill: "#a73b49"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1z",
    fill: "#a4424d"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1z",
    fill: "#ab5059"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-1v-1h1z",
    fill: "#b9656b"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1z",
    fill: "#c87b80"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33h1v1h-1z",
    fill: "#dd9a9d"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33v1h-1v-1z",
    fill: "#e1a8ad",
    fillOpacity: 0.976
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v-1h1v1z",
    fill: "#e0bdbe",
    fillOpacity: 0.561
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#dfdfdf",
    fillOpacity: 0.063
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34v1h-1v-1z",
    fill: "#e2b3b3",
    fillOpacity: 0.212
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35h-1v-1h1z",
    fill: "#e5aaac",
    fillOpacity: 0.58
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35h-1v-1h1z",
    fill: "#dba0a0",
    fillOpacity: 0.878
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M25 34h1v1h-1z",
    fill: "#de9c9b"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M26 34h1v1h-1z",
    fill: "#df9796"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M27 34h1v1h-1z",
    fill: "#d78a8d"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h1v1h-1z",
    fill: "#d17b7f"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M29 35v-1h1v1z",
    fill: "#c36367"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M31 35h-1v-1h1z",
    fill: "#bb4d54"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1z",
    fill: "#b33945"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h1v1h-1z",
    fill: "#b12c3d"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34h1v1h-1z",
    fill: "#a81d2f"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35v-1h1v1z",
    fill: "#a61927"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M36 35h-1v-1h1z",
    fill: "#a41425"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34v1h-1v-1z",
    fill: "#a31220"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-1v-1h1z",
    fill: "#a01118"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1z",
    fill: "#a11218"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35v-1h1v1z",
    fill: "#9f1816"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M41 35h-1v-1h1z",
    fill: "#a51c13"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34v1h-1v-1z",
    fill: "#af2316"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35v-1h1v1z",
    fill: "#a81912"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-1z",
    fill: "#ac1213"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35h-1v-1h1z",
    fill: "#bb1c1e"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1z",
    fill: "#b3171e"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v-1h1v1z",
    fill: "#b03b2a"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35h-1v-1h1z",
    fill: "#975c24"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h-1v-1h1z",
    fill: "#8a581f"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1z",
    fill: "#743d1e"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34h1v1h-1z",
    fill: "#652e1b"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1z",
    fill: "#9b2d3a"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#952538"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#91273c"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1z",
    fill: "#8f263c"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1z",
    fill: "#8b2538"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1z",
    fill: "#8c2c3c"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M57 34h1v1h-1z",
    fill: "#902e3f"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35v-1h1v1z",
    fill: "#983643"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34v1h-1v-1z",
    fill: "#a0404c"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34h1v1h-1z",
    fill: "#ae525a"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35v-1h1v1z",
    fill: "#c36c71"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M63 35h-1v-1h1z",
    fill: "#da9397"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1z",
    fill: "#dda7aa",
    fillOpacity: 0.808
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1z",
    fill: "#ddc5c5",
    fillOpacity: 0.208
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36v-1h1v1z",
    fill: "#daa",
    fillOpacity: 0.294
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M22 36h-1v-1h1z",
    fill: "#d88f92",
    fillOpacity: 0.702
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h1v1h-1z",
    fill: "#d07c7c",
    fillOpacity: 0.976
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35v1h-1v-1z",
    fill: "#d07475"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h-1v-1h1z",
    fill: "#c56569"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M26 35v1h-1v-1z",
    fill: "#bf6165"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M26 36v-1h1v1z",
    fill: "#c0696c"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36h-1v-1h1z",
    fill: "#c56f75"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36h-1v-1h1z",
    fill: "#cf787c"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36v-1h1v1z",
    fill: "#d37b7d"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35h1v1h-1z",
    fill: "#ca646a"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v-1h1v1z",
    fill: "#c24f58"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35h1v1h-1z",
    fill: "#b43640"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M33 35h1v1h-1z",
    fill: "#a6212d"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35h1v1h-1z",
    fill: "#a31a21"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35h1v1h-1z",
    fill: "#a01721"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M37 36h-1v-1h1z",
    fill: "#9c151a"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35v1h-1v-1z",
    fill: "#a41b16"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v-1h1v1z",
    fill: "#9a170e"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#9d240e"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36h-1v-1h1z",
    fill: "#a0240a"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36h-1v-1h1z",
    fill: "#a02106"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35v1h-1v-1z",
    fill: "#9f1a05"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h-1v-1h1z",
    fill: "#b92d1c"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35h1v1h-1z",
    fill: "#c63123"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v1h-1v-1z",
    fill: "#c03226"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36h-1v-1h1z",
    fill: "#ba6a40"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1z",
    fill: "#613f0e"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36v-1h1v1z",
    fill: "#653c16"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1z",
    fill: "#894f24"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1z",
    fill: "#753e1c"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1z",
    fill: "#923130"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#8e162c"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#86162b"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1z",
    fill: "#86192f"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1z",
    fill: "#80192e"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-1h1z",
    fill: "#7e1b2f"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1z",
    fill: "#841c34"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35h1v1h-1z",
    fill: "#902439"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1z",
    fill: "#99283a"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1z",
    fill: "#9a2b37"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#a3343c"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1z",
    fill: "#b54c52"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1z",
    fill: "#ce6d74"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35v1h-1v-1z",
    fill: "#d7949c",
    fillOpacity: 0.922
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36v-1h1v1z",
    fill: "#debec1",
    fillOpacity: 0.278
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M18 37v-1h1v1z",
    fill: "#d5b6b6",
    fillOpacity: 0.192
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M19 36h1v1h-1z",
    fill: "#db9fa0",
    fillOpacity: 0.702
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M20 37v-1h1v1z",
    fill: "#da8b8c"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37h-1v-1h1z",
    fill: "#d7767a"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37v-1h1v1z",
    fill: "#ca5d63"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37h-1v-1h1z",
    fill: "#c5565d"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36h1v1h-1z",
    fill: "#c0565c"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h1v1h-1z",
    fill: "#bf565c"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M27 37h-1v-1h1z",
    fill: "#c1585d"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36v1h-1v-1z",
    fill: "#c25f62"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37h-1v-1h1z",
    fill: "#c06265"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M30 37h-1v-1h1z",
    fill: "#c86b6f"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v1h-1v-1z",
    fill: "#d27274"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36h1v1h-1z",
    fill: "#ca575c"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36h1v1h-1z",
    fill: "#c44a4d"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37v-1h1v1z",
    fill: "#b93f41"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36v1h-1v-1z",
    fill: "#a42620"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1z",
    fill: "#991b15"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37h-1v-1h1z",
    fill: "#9a2117"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v1h-1v-1z",
    fill: "#952110"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1z",
    fill: "#891b04"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37h-1v-1h1z",
    fill: "#912c06"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1z",
    fill: "#982e07"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#932703"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-1v-1h1z",
    fill: "#9c2806"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M43 36h1v1h-1z",
    fill: "#bf4222"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v1h-1z",
    fill: "#c74526"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#cc5d3b"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v1h-1v-1z",
    fill: "#864e1e"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37h-1v-1h1z",
    fill: "#522a0c"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36h1v1h-1z",
    fill: "#451f08"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1z",
    fill: "#65331c"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1z",
    fill: "#a8704e"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#97242d"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1z",
    fill: "#820f24"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#8a142c"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1z",
    fill: "#952335"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1z",
    fill: "#891a2e"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M57 37h-1v-1h1z",
    fill: "#841630"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h-1v-1h1z",
    fill: "#861a32"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M59 37h-1v-1h1z",
    fill: "#8e2038"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h1v1h-1z",
    fill: "#982336"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37h-1v-1h1z",
    fill: "#9b2331"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v1h-1v-1z",
    fill: "#a02732"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36h1v1h-1z",
    fill: "#ac3540"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h-1v-1h1z",
    fill: "#b74452"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1z",
    fill: "#ca616b"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36v1h-1v-1z",
    fill: "#d99197",
    fillOpacity: 0.941
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M67 37h-1v-1h1z",
    fill: "#e3c5c5",
    fillOpacity: 0.259
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38v-1h1v1z",
    fill: "#daacac",
    fillOpacity: 0.412
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M19 37v1h-1v-1z",
    fill: "#dd9a9a",
    fillOpacity: 0.937
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v-1h1v1z",
    fill: "#db8283"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37v1h-1v-1z",
    fill: "#d36c6e"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M22 38h-1v-1h1z",
    fill: "#d25e64"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M23 37v1h-1v-1z",
    fill: "#cc545b"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37v1h-1v-1z",
    fill: "#c7535a"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M25 37v1h-1v-1z",
    fill: "#c8595f"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38v-1h1v1z",
    fill: "#c45c60"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38h-1v-1h1z",
    fill: "#c66165"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38v-1h1v1z",
    fill: "#cb6c6f"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37v1h-1v-1z",
    fill: "#ca7375"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38v-1h1v1z",
    fill: "#cd777a"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37v1h-1v-1z",
    fill: "#ce7279"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38v-1h1v1z",
    fill: "#c4555c"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37h1v1h-1z",
    fill: "#bd4245"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37v1h-1v-1z",
    fill: "#c54c4d"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37h1v1h-1z",
    fill: "#be4845"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37h1v1h-1z",
    fill: "#9c2615"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37v1h-1v-1z",
    fill: "#8d2109"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v-1h1v1z",
    fill: "#8a290c"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37v1h-1v-1z",
    fill: "#802401"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38v-1h1v1z",
    fill: "#822c00"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38h-1v-1h1z",
    fill: "#8b3104"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38h-1v-1h1z",
    fill: "#862a02"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-1h1v1z",
    fill: "#9d3a0c"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h-1v-1h1z",
    fill: "#cb5e32"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38v-1h1v1z",
    fill: "#ce6436"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1z",
    fill: "#b46629"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v-1h1v1z",
    fill: "#793d0d"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37v1h-1v-1z",
    fill: "#532011"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v-1h1v1z",
    fill: "#2d0802"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h1v1z",
    fill: "#551511"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h-1v-1h1z",
    fill: "#b8574e"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1z",
    fill: "#9b2837"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1z",
    fill: "#952e3a"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1z",
    fill: "#952f3a"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1z",
    fill: "#942e3c"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h-1v-1h1z",
    fill: "#942d3e"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h1v1h-1z",
    fill: "#942b3f"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-1v-1z",
    fill: "#962a40"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h1v1h-1z",
    fill: "#95253b"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1z",
    fill: "#9d2234"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1z",
    fill: "#ae2f3d"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#ab2d37"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M62 37h1v1h-1z",
    fill: "#b93d4c"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1z",
    fill: "#cb5b74"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v1h-1z",
    fill: "#ca5b73"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v-1h1v1z",
    fill: "#cc616d"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h1v1h-1z",
    fill: "#d89495",
    fillOpacity: 0.89
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M68 38h-1v-1h1z",
    fill: "#e9cccc",
    fillOpacity: 0.137
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M16 38v1h-1v-1z",
    fill: "#cff",
    fillOpacity: 0.02
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M16 39v-1h1v1z",
    fill: "#dca2a2",
    fillOpacity: 0.584
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38h1v1h-1z",
    fill: "#e39495"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v1h-1v-1z",
    fill: "#da7577"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39v-1h1v1z",
    fill: "#d56066"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39h-1v-1h1z",
    fill: "#cd555c"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h-1v-1h1z",
    fill: "#c3484f"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v-1h1v1z",
    fill: "#bf454d"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M24 38v1h-1v-1z",
    fill: "#be4950"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M25 39h-1v-1h1z",
    fill: "#b7474e"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M26 38v1h-1v-1z",
    fill: "#b2494f"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M26 39v-1h1v1z",
    fill: "#b45055"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38v1h-1v-1z",
    fill: "#c25e66"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v-1h1v1z",
    fill: "#c96f74"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38h1v1h-1z",
    fill: "#d58c8d"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38h1v1h-1z",
    fill: "#d07a7e"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38h1v1h-1z",
    fill: "#b6444c"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38v1h-1v-1z",
    fill: "#b02e35"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v-1h1v1z",
    fill: "#b7373b"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38h1v1h-1z",
    fill: "#d97083"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38v1h-1v-1z",
    fill: "#bd5f52"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v1h-1v-1z",
    fill: "#892902"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38v1h-1v-1z",
    fill: "#7c2902"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38h1v1h-1z",
    fill: "#7c2d02"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39h-1v-1h1z",
    fill: "#803402"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v-1h1v1z",
    fill: "#803504"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39h-1v-1h1z",
    fill: "#813202"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39h-1v-1h1z",
    fill: "#a54b14"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M43 38h1v1h-1z",
    fill: "#cc6832"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h1v1h-1z",
    fill: "#b96622"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v1h-1v-1z",
    fill: "#81390a"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M47 38v1h-1v-1z",
    fill: "#521405"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v1h-1v-1z",
    fill: "#370809"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v1h-1v-1z",
    fill: "#541516"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1z",
    fill: "#9c2f33"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1z",
    fill: "#b33f43"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#bc4e51"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v1z",
    fill: "#bb5255"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#b84f53"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1z",
    fill: "#b14a51"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-1v-1z",
    fill: "#a9434e"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M57 38v1h-1v-1z",
    fill: "#a43c49"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M58 39h-1v-1h1z",
    fill: "#a43643"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38v1h-1v-1z",
    fill: "#a23040"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1z",
    fill: "#a32a39"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1z",
    fill: "#a42733"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38v1h-1v-1z",
    fill: "#aa2c38"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h1v1h-1z",
    fill: "#c34d64"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#ce627f"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1z",
    fill: "#cb6379"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M66 39h-1v-1h1z",
    fill: "#cd6176"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38v1h-1v-1z",
    fill: "#d0636d"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38h1v1h-1z",
    fill: "#da999b",
    fillOpacity: 0.722
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.027
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40v-1h1v1z",
    fill: "#de9e9e",
    fillOpacity: 0.612
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40h-1v-1h1z",
    fill: "#e48a8a"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M18 39v1h-1v-1z",
    fill: "#d96970"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M18 40v-1h1v1z",
    fill: "#d95c64"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39h1v1h-1z",
    fill: "#cc4f57"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40v-1h1v1z",
    fill: "#c1414d"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v1h-1v-1z",
    fill: "#ba3b47"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h1v1h-1z",
    fill: "#b43843"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M23 39h1v1h-1z",
    fill: "#b2333f"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h-1v-1h1z",
    fill: "#b23843"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40v-1h1v1z",
    fill: "#b2424b"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M27 39v1h-1v-1z",
    fill: "#b24a50"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v1h-1v-1z",
    fill: "#b45156"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h-1v-1h1z",
    fill: "#b7555b"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M30 39v1h-1v-1z",
    fill: "#c16369"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40h-1v-1h1z",
    fill: "#d1797c"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v-1h1v1z",
    fill: "#cd6d70"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v1h-1v-1z",
    fill: "#bd4b4f"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39h1v1h-1z",
    fill: "#bb3d45"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v-1h1v1z",
    fill: "#c1545f"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39v1h-1v-1z",
    fill: "#d57673"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39h1v1h-1z",
    fill: "#9a4617"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M37 40v-1h1v1z",
    fill: "#772f00"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40h-1v-1h1z",
    fill: "#733203"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v1h-1v-1z",
    fill: "#753602"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39v1h-1v-1z",
    fill: "#743103"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39h1v1h-1z",
    fill: "#803a05"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40h-1v-1h1z",
    fill: "#a45014"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M44 39v1h-1v-1z",
    fill: "#b05724"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M44 40v-1h1v1z",
    fill: "#722606"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h-1v-1h1z",
    fill: "#3e0604"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M47 40h-1v-1h1z",
    fill: "#8a2c26"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39h1v1h-1z",
    fill: "#b33d38"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h-1v-1h1z",
    fill: "#c04244"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1z",
    fill: "#c24b51"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39v1h-1v-1z",
    fill: "#bf5d5f"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1z",
    fill: "#c25e62"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#b9555a"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#af4d52"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1z",
    fill: "#ac4850"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40h-1v-1h1z",
    fill: "#ad4851"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40v-1h1v1z",
    fill: "#af4854"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#b04751"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M59 39v1h-1v-1z",
    fill: "#b1404b"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1z",
    fill: "#b03844"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1z",
    fill: "#ab3038"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#b53843"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1z",
    fill: "#cd5f7b"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M63 39h1v1h-1z",
    fill: "#d26d8f"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v1h-1v-1z",
    fill: "#c55567"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#cd5e72"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#c75765"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#cf7174"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1z",
    fill: "#e6b6b2",
    fillOpacity: 0.247
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41v-1h1v1z",
    fill: "#d79999",
    fillOpacity: 0.529
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40h1v1h-1z",
    fill: "#e37f83"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40v1h-1v-1z",
    fill: "#dc6a6d"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40h1v1h-1z",
    fill: "#de6065"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M19 41h-1v-1h1z",
    fill: "#d55158"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41h-1v-1h1z",
    fill: "#c94248"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40h1v1h-1z",
    fill: "#c33b45"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h-1v-1h1z",
    fill: "#b7303e"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41h-1v-1h1z",
    fill: "#b02b39"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41v-1h1v1z",
    fill: "#b93341"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M24 41v-1h1v1z",
    fill: "#b83c48"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h1v1h-1z",
    fill: "#a73641"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M27 41h-1v-1h1z",
    fill: "#a53943"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M27 40h1v1h-1z",
    fill: "#a53c44"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40v1h-1v-1z",
    fill: "#b1444d"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h1v1h-1z",
    fill: "#bc4e55"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v1h-1v-1z",
    fill: "#c0555b"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41v-1h1v1z",
    fill: "#c56166"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40h1v1h-1z",
    fill: "#c76e71"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v1h-1v-1z",
    fill: "#c87276"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v-1h1v1z",
    fill: "#c6656a"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1z",
    fill: "#b4524a"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h-1v-1h1z",
    fill: "#a6522c"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41h-1v-1h1z",
    fill: "#753203"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h-1v-1h1z",
    fill: "#6b3101"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M40 41h-1v-1h1z",
    fill: "#692f00"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40v1h-1v-1z",
    fill: "#662d00"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h-1v-1h1z",
    fill: "#793901"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40v1h-1v-1z",
    fill: "#924608"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M43 41v-1h1v1z",
    fill: "#661c06"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M45 40v1h-1v-1z",
    fill: "#3a0406"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v-1h1v1z",
    fill: "#803228"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h1v1h-1z",
    fill: "#c84837"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40v1h-1v-1z",
    fill: "#bf3934"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1z",
    fill: "#b1393d"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h1v1h-1z",
    fill: "#b85457"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41v-1h1v1z",
    fill: "#bb6262"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1z",
    fill: "#b15d60"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v-1h1v1z",
    fill: "#a34a50"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1z",
    fill: "#9c3e48"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1z",
    fill: "#963a45"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1z",
    fill: "#9b3943"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h-1v-1h1z",
    fill: "#a8404a"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M58 40v1h-1v-1z",
    fill: "#a73e49"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M59 41h-1v-1h1z",
    fill: "#aa3f47"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#b5424c"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1z",
    fill: "#bb3e47"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#bc4050"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v-1h1v1z",
    fill: "#ce5f7c"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41v-1h1v1z",
    fill: "#dc7ba0"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1z",
    fill: "#d1637c"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#c9535f"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#cb555e"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#cd5a5b"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#d78989",
    fillOpacity: 0.306
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41v1h-1v-1z",
    fill: "#d89a9d",
    fillOpacity: 0.42
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42h-1v-1h1z",
    fill: "#e28082"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42v-1h1v1z",
    fill: "#e0706f"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42h-1v-1h1z",
    fill: "#e16364"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M18 41v1h-1v-1z",
    fill: "#e15e5f"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42v-1h1v1z",
    fill: "#d64d4d"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41v1h-1v-1z",
    fill: "#cb4140"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M21 41v1h-1v-1z",
    fill: "#c5393d"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42v-1h1v1z",
    fill: "#bc303a"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h1v1h-1z",
    fill: "#bc323f"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42h-1v-1h1z",
    fill: "#a92e3b"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42v-1h1v1z",
    fill: "#a12b3a"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M26 41h1v1h-1z",
    fill: "#a6303e"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42v-1h1v1z",
    fill: "#bb404f"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42h-1v-1h1z",
    fill: "#bd3e4f"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41v1h-1v-1z",
    fill: "#b13d48"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M31 42h-1v-1h1z",
    fill: "#b0404b"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41v1h-1v-1z",
    fill: "#ae4550"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41v1h-1v-1z",
    fill: "#a3444f"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v1h-1v-1z",
    fill: "#a85059"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41v1h-1v-1z",
    fill: "#bb626a"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42h-1v-1h1z",
    fill: "#b9696d"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#b66668"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1z",
    fill: "#ab5f5c"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41v1h-1v-1z",
    fill: "#a35a4e"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h1v1h-1z",
    fill: "#9b513e"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42h-1v-1h1z",
    fill: "#904833"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42h-1v-1h1z",
    fill: "#97472b"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h1v1h-1z",
    fill: "#974624"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M44 42h-1v-1h1z",
    fill: "#72281b"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v1h-1v-1z",
    fill: "#590f0f"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42h-1v-1h1z",
    fill: "#892019"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-1v-1z",
    fill: "#8a1814"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1z",
    fill: "#a33333"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#ad4c4e"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1z",
    fill: "#b85d62"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41v1h-1v-1z",
    fill: "#bf6667"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#b55c5e"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1z",
    fill: "#a84a50"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-1v-1h1z",
    fill: "#a03c46"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1z",
    fill: "#983541"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42v-1h1v1z",
    fill: "#952f3d"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1z",
    fill: "#9a2f3e"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h1v1h-1z",
    fill: "#9d303e"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1z",
    fill: "#a0323b"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42v-1h1v1z",
    fill: "#a83740"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1z",
    fill: "#b6414a"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1z",
    fill: "#c34450"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h1v1h-1z",
    fill: "#c95269"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#d26c8c"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1z",
    fill: "#d77290"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#cd5a69"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#d15359"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#d15655"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#ca7371",
    fillOpacity: 0.475
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M13 42v1h-1v-1z",
    fill: "#e6b6b6",
    fillOpacity: 0.208
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M14 43h-1v-1h1z",
    fill: "#db8383",
    fillOpacity: 0.953
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M14 43v-1h1v1z",
    fill: "#e67472"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M15 43v-1h1v1z",
    fill: "#e26a6a"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42v1h-1v-1z",
    fill: "#db5e5a"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42h1v1h-1z",
    fill: "#da5451"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42h1v1h-1z",
    fill: "#d94f4c"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M20 42v1h-1v-1z",
    fill: "#d34a45"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M21 43h-1v-1h1z",
    fill: "#ca413e"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42h1v1h-1z",
    fill: "#c63e3e"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43h-1v-1h1z",
    fill: "#c13940"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42v1h-1v-1z",
    fill: "#b2323d"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43v-1h1v1z",
    fill: "#a92b37"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43v-1h1v1z",
    fill: "#a82534"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M26 43v-1h1v1z",
    fill: "#b32c3c"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42h1v1h-1z",
    fill: "#b93142"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42v1h-1v-1z",
    fill: "#ae3143"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43v-1h1v1z",
    fill: "#a83746"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42h1v1h-1z",
    fill: "#a7394a"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43v-1h1v1z",
    fill: "#9d3848"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-1z",
    fill: "#953949"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42v1h-1v-1z",
    fill: "#983b4c"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v1h-1z",
    fill: "#963b4a"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42v1h-1v-1z",
    fill: "#913d48"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1z",
    fill: "#943f4c"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43h-1v-1h1z",
    fill: "#994954"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42h1v1h-1z",
    fill: "#a04c5b"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1z",
    fill: "#ad5562"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1z",
    fill: "#b05761"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h-1v-1h1z",
    fill: "#aa585f"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42v1h-1v-1z",
    fill: "#af5860"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43v-1h1v1z",
    fill: "#af575e"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43h-1v-1h1z",
    fill: "#973335"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42v1h-1v-1z",
    fill: "#800c13"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M46 43v-1h1v1z",
    fill: "#6b0001"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42v1h-1v-1z",
    fill: "#690000"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1z",
    fill: "#740b0f"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h1v1h-1z",
    fill: "#943038"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#a5464c"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#a9464e"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h-1v-1h1z",
    fill: "#a84049"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43v-1h1v1z",
    fill: "#a73843"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1z",
    fill: "#a63540"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1z",
    fill: "#a63442"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h1v1z",
    fill: "#9f2f3d"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1z",
    fill: "#9b2a34"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43v-1h1v1z",
    fill: "#9d2730"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1z",
    fill: "#ae333f"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42h1v1h-1z",
    fill: "#bd4350"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1z",
    fill: "#c54755"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M63 42v1h-1v-1z",
    fill: "#c84f60"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-1h1v1z",
    fill: "#d76780"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1z",
    fill: "#d56987"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1z",
    fill: "#ce5d6d"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#ce5258"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v1h-1v-1z",
    fill: "#db5855"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1z",
    fill: "#d36765",
    fillOpacity: 0.831
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M12 44h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.039
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M13 44h-1v-1h1z",
    fill: "#de9294",
    fillOpacity: 0.796
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M13 43h1v1h-1z",
    fill: "#e87476"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M15 44h-1v-1h1z",
    fill: "#e26c6b"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M16 43v1h-1v-1z",
    fill: "#de6362"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v-1h1v1z",
    fill: "#df5e58"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M18 43v1h-1v-1z",
    fill: "#e15f58"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M19 44h-1v-1h1z",
    fill: "#e25f58"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h-1v-1h1z",
    fill: "#d8514d"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44h-1v-1h1z",
    fill: "#d24c47"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44v-1h1v1z",
    fill: "#cb4743"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43v1h-1v-1z",
    fill: "#c24141"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44h-1v-1h1z",
    fill: "#b6363d"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M25 44h-1v-1h1z",
    fill: "#b42f38"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44h-1v-1h1z",
    fill: "#b32632"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44h-1v-1h1z",
    fill: "#b82735"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44v-1h1v1z",
    fill: "#ac2233"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M28 44v-1h1v1z",
    fill: "#a52435"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h-1v-1h1z",
    fill: "#a8293d"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44v-1h1v1z",
    fill: "#9e293d"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43h1v1h-1z",
    fill: "#94293c"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v-1h1v1z",
    fill: "#8c293b"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44v-1h1v1z",
    fill: "#8a2739"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43v1h-1v-1z",
    fill: "#90283e"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44h-1v-1h1z",
    fill: "#85293d"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-1v-1h1z",
    fill: "#842d40"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43v1h-1v-1z",
    fill: "#852c3e"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44v-1h1v1z",
    fill: "#852f40"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43v1h-1v-1z",
    fill: "#8a3243"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M41 43v1h-1v-1z",
    fill: "#8c3342"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43v1h-1v-1z",
    fill: "#8f3244"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h1v1h-1z",
    fill: "#8b3346"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43h1v1h-1z",
    fill: "#8f3843"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43v1h-1v-1z",
    fill: "#95333e"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M45 44v-1h1v1z",
    fill: "#8a1421"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1z",
    fill: "#7d0b17"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-1v-1z",
    fill: "#7d0b18"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1z",
    fill: "#8a1423"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-1z",
    fill: "#922235"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#97313f"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1z",
    fill: "#9c3341"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M53 44h-1v-1h1z",
    fill: "#a03443"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#a23240"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#a2303c"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1z",
    fill: "#a22e3a"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v1h-1v-1z",
    fill: "#9f2a35"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44h-1v-1h1z",
    fill: "#a52a32"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43h1v1h-1z",
    fill: "#aa2d34"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1z",
    fill: "#b13a46"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#cb5165"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#cb5267"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1z",
    fill: "#c44e5e"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1z",
    fill: "#cc5264"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1z",
    fill: "#d86076"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1z",
    fill: "#d25c6b"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43v1h-1v-1z",
    fill: "#cf545e"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1z",
    fill: "#dd5852",
    fillOpacity: 0.988
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43v1h-1v-1z",
    fill: "#d2605e",
    fillOpacity: 0.541
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.027
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M11 45v-1h1v1z",
    fill: "#dea19f",
    fillOpacity: 0.494
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M13 44v1h-1v-1z",
    fill: "#e5817f"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M14 45h-1v-1h1z",
    fill: "#e66f6e"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M15 44v1h-1v-1z",
    fill: "#e36665"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v1h-1v-1z",
    fill: "#e46460"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45h-1v-1h1z",
    fill: "#eb6e66"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44v1h-1v-1z",
    fill: "#ed746a"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44h1v1h-1z",
    fill: "#e76c62"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v-1h1v1z",
    fill: "#e15f57"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h1v1h-1z",
    fill: "#de5b54"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44v1h-1v-1z",
    fill: "#d05049"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M23 45h-1v-1h1z",
    fill: "#ca4942"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M23 44h1v1h-1z",
    fill: "#ca4341"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h-1v-1h1z",
    fill: "#c43636"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44v1h-1v-1z",
    fill: "#c43233"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45h-1v-1h1z",
    fill: "#c12e34"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45v-1h1v1z",
    fill: "#ae2231"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h-1v-1h1z",
    fill: "#a9202e"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-1v-1h1z",
    fill: "#9f1a28"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h1v1h-1z",
    fill: "#9d2133"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v1h-1v-1z",
    fill: "#921c31"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1z",
    fill: "#861a2c"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44v1h-1v-1z",
    fill: "#8c2032"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v-1h1v1z",
    fill: "#8f2337"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1z",
    fill: "#7c1c2f"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45h-1v-1h1z",
    fill: "#7c1d30"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1z",
    fill: "#902539"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44h1v1h-1z",
    fill: "#8c2735"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45h-1v-1h1z",
    fill: "#812334"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M41 44v1h-1v-1z",
    fill: "#832236"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45h-1v-1h1z",
    fill: "#852236"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v-1h1v1z",
    fill: "#832638"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-1h1v1z",
    fill: "#872637"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45h-1v-1h1z",
    fill: "#8f2739"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44v1h-1v-1z",
    fill: "#8a2336"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1z",
    fill: "#882235"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1z",
    fill: "#902134"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1z",
    fill: "#942334"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#911d33"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#921f33"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1z",
    fill: "#972436"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1z",
    fill: "#9e283a"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1z",
    fill: "#a12a3b"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1z",
    fill: "#a02937"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1z",
    fill: "#9e2730"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1z",
    fill: "#9b262d"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#a62e35"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45v-1h1v1z",
    fill: "#c04353"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1z",
    fill: "#c85571"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#d57293"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1z",
    fill: "#dc7898"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1z",
    fill: "#d25f75"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#cd4d59"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44v1h-1v-1z",
    fill: "#d1545f"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1z",
    fill: "#da5b65"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1z",
    fill: "#de565c"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1z",
    fill: "#d05650",
    fillOpacity: 0.6
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M10 46v-1h1v1z",
    fill: "#d7c4c4",
    fillOpacity: 0.051
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M12 45v1h-1v-1z",
    fill: "#dd8584",
    fillOpacity: 0.878
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M13 46h-1v-1h1z",
    fill: "#e87473"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M14 46h-1v-1h1z",
    fill: "#e96f6b"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M15 45v1h-1v-1z",
    fill: "#e5635e"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M16 46h-1v-1h1z",
    fill: "#f27772"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M16 45h1v1h-1z",
    fill: "#f68b84"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45h1v1h-1z",
    fill: "#f38883"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v1h-1v-1z",
    fill: "#ef7b74"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46v-1h1v1z",
    fill: "#e96d63"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M20 45h1v1h-1z",
    fill: "#e3695e"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M21 46v-1h1v1z",
    fill: "#d45c52"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v-1h1v1z",
    fill: "#d8574b"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45v1h-1v-1z",
    fill: "#dd544b"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46h-1v-1h1z",
    fill: "#d3473f"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h1v1h-1z",
    fill: "#ca3e37"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46h-1v-1h1z",
    fill: "#bb3130"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46h-1v-1h1z",
    fill: "#ad242f"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46v-1h1v1z",
    fill: "#ab202b"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h1v1h-1z",
    fill: "#ac2931"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45v1h-1v-1z",
    fill: "#931b26"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46v-1h1v1z",
    fill: "#841322"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M33 45v1h-1v-1z",
    fill: "#861828"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v1h-1v-1z",
    fill: "#861628"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1z",
    fill: "#7d1426"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45v1h-1v-1z",
    fill: "#791629"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h1v1z",
    fill: "#79162a"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1z",
    fill: "#881a31"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M39 46h-1v-1h1z",
    fill: "#881930"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46h-1v-1h1z",
    fill: "#7a162a"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M41 46h-1v-1h1z",
    fill: "#7e1729"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M42 46h-1v-1h1z",
    fill: "#80172a"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v1h-1v-1z",
    fill: "#7f182a"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-1v-1z",
    fill: "#821c2a"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45h1v1h-1z",
    fill: "#871d2b"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1z",
    fill: "#84192c"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#81182c"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h-1v-1h1z",
    fill: "#861528"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#8b1729"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#92162a"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#8c1224"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1z",
    fill: "#901429"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1z",
    fill: "#99192d"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1z",
    fill: "#9a192b"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1z",
    fill: "#9b1d27"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45v1h-1v-1z",
    fill: "#a02326"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1z",
    fill: "#a93031"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46h-1v-1h1z",
    fill: "#b33d43"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45h1v1h-1z",
    fill: "#d05e74"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1z",
    fill: "#df7a9c"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1z",
    fill: "#e38faf"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h1v1h-1z",
    fill: "#e99dc1"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1z",
    fill: "#e182a4"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1z",
    fill: "#d55a6a"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46v-1h1v1z",
    fill: "#d04f53"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46h-1v-1h1z",
    fill: "#dd575c"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45v1h-1v-1z",
    fill: "#e05e58",
    fillOpacity: 0.922
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1z",
    fill: "#ca6960",
    fillOpacity: 0.114
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M11 46v1h-1v-1z",
    fill: "#de8585",
    fillOpacity: 0.337
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47h-1v-1h1z",
    fill: "#e87b79",
    fillOpacity: 0.996
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M12 46h1v1h-1z",
    fill: "#ea7270"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M13 47v-1h1v1z",
    fill: "#ed6865"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M15 47h-1v-1h1z",
    fill: "#ee6e69"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M16 46v1h-1v-1z",
    fill: "#f48e87"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M17 47h-1v-1h1z",
    fill: "#f6a29e"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M18 46v1h-1v-1z",
    fill: "#f9a7a4"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47h-1v-1h1z",
    fill: "#f29089"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46h1v1h-1z",
    fill: "#ef8279"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M20 46h1v1h-1z",
    fill: "#e7756b"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v1h-1v-1z",
    fill: "#e17165"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h-1v-1h1z",
    fill: "#e96f61"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47v-1h1v1z",
    fill: "#e2604e"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47h-1v-1h1z",
    fill: "#db5846"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M26 47h-1v-1h1z",
    fill: "#cd4c3d"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46v1h-1v-1z",
    fill: "#bf3f35"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47h-1v-1h1z",
    fill: "#ad2b2d"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h-1v-1h1z",
    fill: "#a62127"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M29 46h1v1h-1z",
    fill: "#9c2225"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M31 47h-1v-1h1z",
    fill: "#8f1920"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46h1v1h-1z",
    fill: "#85121f"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46v1h-1v-1z",
    fill: "#8f1628"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47h-1v-1h1z",
    fill: "#850f21"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47h-1v-1h1z",
    fill: "#770f1f"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47h-1v-1h1z",
    fill: "#770d21"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46v1h-1v-1z",
    fill: "#7a0e25"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#7d1027"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#7c0f26"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M39 47v-1h1v1z",
    fill: "#790d22"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#7c1123"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47h-1v-1h1z",
    fill: "#7f1627"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1z",
    fill: "#7e1326"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1z",
    fill: "#821425"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47v-1h1v1z",
    fill: "#851224"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1z",
    fill: "#830e23"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1z",
    fill: "#800d22"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M47 46h1v1h-1z",
    fill: "#840c22"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h1v1h-1z",
    fill: "#840b1f"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1z",
    fill: "#8e0e20"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1z",
    fill: "#951523"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1z",
    fill: "#8c081d"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#91071d"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1z",
    fill: "#960d1d"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47v-1h1v1z",
    fill: "#99181d"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-1v-1z",
    fill: "#aa2a2a"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1z",
    fill: "#bc3f42"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1z",
    fill: "#cf5c6c"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1z",
    fill: "#df7b98"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47v-1h1v1z",
    fill: "#ea99bb"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#eea5c6"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#eaa5c3"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47h-1v-1h1z",
    fill: "#e793b0"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-1z",
    fill: "#d76276"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1z",
    fill: "#d25053"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1z",
    fill: "#dd5256"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1z",
    fill: "#de6660",
    fillOpacity: 0.843
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M10 48H9v-1h1z",
    fill: "#faa",
    fillOpacity: 0.012
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M10 47h1v1h-1z",
    fill: "#e47c7c",
    fillOpacity: 0.722
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47v1h-1v-1z",
    fill: "#f27d71"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M12 48v-1h1v1z",
    fill: "#f79778"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M14 47v1h-1v-1z",
    fill: "#fea98d"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M14 48v-1h1v1z",
    fill: "#f78b81"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M15 48v-1h1v1z",
    fill: "#f69a96"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M16 47h1v1h-1z",
    fill: "#f8aca9"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M17 47h1v1h-1z",
    fill: "#f8aeae"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47v1h-1v-1z",
    fill: "#fbadac"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M19 48v-1h1v1z",
    fill: "#f5a098"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48h-1v-1h1z",
    fill: "#ef8f86"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M21 47h1v1h-1z",
    fill: "#ef897d"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48h-1v-1h1z",
    fill: "#f08273"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h1v1h-1z",
    fill: "#ec7460"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47v1h-1v-1z",
    fill: "#e0664e"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48v-1h1v1z",
    fill: "#d15842"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48h-1v-1h1z",
    fill: "#c14535"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48v-1h1v1z",
    fill: "#ad302c"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M29 48h-1v-1h1z",
    fill: "#a22528"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h1v1h-1z",
    fill: "#9d1d21"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h-1v-1h1z",
    fill: "#941520"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48h-1v-1h1z",
    fill: "#840b1c"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#8d1121"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47v1h-1v-1z",
    fill: "#7f0918"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#710817"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-1v-1z",
    fill: "#720719"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v1h-1v-1z",
    fill: "#7d081f"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47h1v1h-1z",
    fill: "#7b0c20"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#7c101f"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1z",
    fill: "#7e1220"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#7b0d1f"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1z",
    fill: "#7e1125"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-1z",
    fill: "#7e1023"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#800d1f"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h1v1h-1z",
    fill: "#84081b"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1z",
    fill: "#89091c"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1z",
    fill: "#810717"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h1v1h-1z",
    fill: "#830819"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h1v1h-1z",
    fill: "#850819"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1z",
    fill: "#8b0716"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48h-1v-1h1z",
    fill: "#900717"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1z",
    fill: "#8f0515"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1z",
    fill: "#920515"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1z",
    fill: "#910512"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48v-1h1v1z",
    fill: "#971116"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48v-1h1v1z",
    fill: "#ac2a2c"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-1z",
    fill: "#cb5156"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47v1h-1v-1z",
    fill: "#d86c7b"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-1v-1h1z",
    fill: "#e490a8"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1z",
    fill: "#ecaac5"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#eeabc4"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1z",
    fill: "#e9a0bc"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-1h1v1z",
    fill: "#e890ab"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h1z",
    fill: "#df6c7c"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1z",
    fill: "#d84f50"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#e35655"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47h1v1h-1z",
    fill: "#d55f57",
    fillOpacity: 0.694
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#7fffff",
    fillOpacity: 0.008
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M10 49H9v-1h1z",
    fill: "#d79c9c",
    fillOpacity: 0.051
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M11 49h-1v-1h1z",
    fill: "#e77e78",
    fillOpacity: 0.835
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M12 49h-1v-1h1z",
    fill: "#ed916b",
    fillOpacity: 0.847
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49h-1v-1h1z",
    fill: "#f6c695",
    fillOpacity: 0.369
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M14 49h-1v-1h1z",
    fill: "#f9d9b9",
    fillOpacity: 0.502
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M15 49h-1v-1h1z",
    fill: "#f8d1b3",
    fillOpacity: 0.969
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M15 49v-1h1v1z",
    fill: "#fbc0a7"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M16 49v-1h1v1z",
    fill: "#ef9f90"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M17 48h1v1h-1z",
    fill: "#f2a091"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M18 48h1v1h-1z",
    fill: "#f6aaa3"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M19 49v-1h1v1z",
    fill: "#f9b4af"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48v1h-1v-1z",
    fill: "#f5aea8"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M22 49h-1v-1h1z",
    fill: "#f5a79f"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48v1h-1v-1z",
    fill: "#f39489"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M24 49h-1v-1h1z",
    fill: "#f18372"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M25 49h-1v-1h1z",
    fill: "#e6755c"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48h1v1h-1z",
    fill: "#d56448"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h-1v-1h1z",
    fill: "#c45137"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48v1h-1v-1z",
    fill: "#b0382c"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M29 49h-1v-1h1z",
    fill: "#9c1c1e"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h-1v-1h1z",
    fill: "#970e19"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49h-1v-1h1z",
    fill: "#8f0918"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h1v1h-1z",
    fill: "#820417"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1z",
    fill: "#7e0314"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#750210"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#6e0412"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1z",
    fill: "#710311"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#7c0111"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v1h-1v-1z",
    fill: "#780315"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1z",
    fill: "#7b0917"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h-1v-1h1z",
    fill: "#7f0b19"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49h-1v-1h1z",
    fill: "#7b0816"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1z",
    fill: "#7f0c1b"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#7c0918"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48h1v1h-1z",
    fill: "#840b1b"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48v1h-1v-1z",
    fill: "#850615"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1z",
    fill: "#8f0a16"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1z",
    fill: "#8d0913"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1z",
    fill: "#890512"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1z",
    fill: "#870411"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49v-1h1v1z",
    fill: "#8e0510"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49v-1h1v1z",
    fill: "#96070e"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#95050a"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1z",
    fill: "#9c090e"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#9e0d12"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48h1v1h-1z",
    fill: "#a00c0e"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48h1v1h-1z",
    fill: "#aa231e"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1z",
    fill: "#cd534e"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49v-1h1v1z",
    fill: "#e1737b"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M59 49h-1v-1h1z",
    fill: "#e590a0"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49h-1v-1h1z",
    fill: "#e9a5bd"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-1z",
    fill: "#eda1b8"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1z",
    fill: "#eb98af"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1z",
    fill: "#e6879f"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1z",
    fill: "#eb757f"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#e67061",
    fillOpacity: 0.914
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h1v1z",
    fill: "#d15b51",
    fillOpacity: 0.416
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48v1h-1v-1z",
    fill: "#b97373",
    fillOpacity: 0.043
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M10 50v-1h1v1z",
    fill: "#f3b1a6",
    fillOpacity: 0.09
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M11 49h1v1h-1z",
    fill: "#eca",
    fillOpacity: 0.059
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M15 50h-1v-1h1z",
    fill: "#f9e4ca",
    fillOpacity: 0.38
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M16 49v1h-1v-1z",
    fill: "#ffe6c3",
    fillOpacity: 0.969
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M17 49v1h-1v-1z",
    fill: "#ffdfb6"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50v-1h1v1z",
    fill: "#f9c1a3"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M19 50h-1v-1h1z",
    fill: "#f2a09b"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M20 50h-1v-1h1z",
    fill: "#f8c1c0"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M20 50v-1h1v1z",
    fill: "#facece"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M21 49h1v1h-1z",
    fill: "#f9c6c5"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M23 50h-1v-1h1z",
    fill: "#f7b0ab"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h-1v-1h1z",
    fill: "#f6988b"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50v-1h1v1z",
    fill: "#ec836d"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M26 49v1h-1v-1z",
    fill: "#de6f53"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49v1h-1v-1z",
    fill: "#cf583c"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h1v1h-1z",
    fill: "#b6372a"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M28 49h1v1h-1z",
    fill: "#9e1a1c"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49v1h-1v-1z",
    fill: "#940813"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h1v1h-1z",
    fill: "#8a040f"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v1h-1v-1z",
    fill: "#83030f"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v-1h1v1z",
    fill: "#7d020c"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M34 49v1h-1v-1z",
    fill: "#72010c"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v-1h1v1z",
    fill: "#6a000d"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h1v1h-1z",
    fill: "#72010a"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1z",
    fill: "#83030b"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v-1h1v1z",
    fill: "#7c010b"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M39 49v1h-1v-1z",
    fill: "#7c040d"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1z",
    fill: "#7e050e"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h1v1h-1z",
    fill: "#7c030c"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M42 49v1h-1v-1z",
    fill: "#7c040e"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50v-1h1v1z",
    fill: "#7c030e"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h1v1h-1z",
    fill: "#86020d"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49h1v1h-1z",
    fill: "#880008"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1z",
    fill: "#9d0f13"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1z",
    fill: "#a00a0e"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fill: "#9d0409"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#930006"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#970507"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49h1v1h-1z",
    fill: "#a00406"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1z",
    fill: "#a10204"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1z",
    fill: "#a60405"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#b91b17"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1z",
    fill: "#b51f11"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1z",
    fill: "#b53e1d"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v-1h1v1z",
    fill: "#cb5b31"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49h1v1h-1z",
    fill: "#db725e"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h1v1h-1z",
    fill: "#e9868a"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1z",
    fill: "#e78890"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1z",
    fill: "#e7838b"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1z",
    fill: "#e77f89"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1z",
    fill: "#ec808d"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h1v1h-1z",
    fill: "#f3727a"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#e98675",
    fillOpacity: 0.416
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M16 51h-1v-1h1z",
    fill: "#f5e2ce",
    fillOpacity: 0.208
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50v1h-1v-1z",
    fill: "#f7e6c5",
    fillOpacity: 0.659
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50h1v1h-1z",
    fill: "#ffdfbe"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M18 50h1v1h-1z",
    fill: "#fcbeb6"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M19 51v-1h1v1z",
    fill: "#f9bbbb"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51h-1v-1h1z",
    fill: "#fbcfcf"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M22 51h-1v-1h1z",
    fill: "#fbd6d3"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M22 50h1v1h-1z",
    fill: "#fcc0c0"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h-1v-1h1z",
    fill: "#f8a094"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h1v1h-1z",
    fill: "#ee8772"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M26 50v1h-1v-1z",
    fill: "#e67358"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51h-1v-1h1z",
    fill: "#ce553a"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v-1h1v1z",
    fill: "#b02e23"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M29 50v1h-1v-1z",
    fill: "#a61f20"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51h-1v-1h1z",
    fill: "#970f15"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51v-1h1v1z",
    fill: "#8d0811"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v1h-1v-1z",
    fill: "#8b0209"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51h-1v-1h1z",
    fill: "#820205"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51h-1v-1h1z",
    fill: "#720108"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#6e0008"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51h-1v-1h1z",
    fill: "#790109"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v1h-1v-1z",
    fill: "#86040b"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50h1v1h-1z",
    fill: "#820208"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v1h-1z",
    fill: "#810307"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1z",
    fill: "#83060a"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1z",
    fill: "#85050a"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#810107"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-1z",
    fill: "#800003"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50h1v1h-1z",
    fill: "#9a150d"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50h1v1h-1z",
    fill: "#ab361e"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1z",
    fill: "#b84e26"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1z",
    fill: "#c96c35"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1z",
    fill: "#c96933"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1z",
    fill: "#c04a27"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1z",
    fill: "#ae190c"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M50 51v-1h1v1z",
    fill: "#b41f0f"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1z",
    fill: "#c04223"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1z",
    fill: "#ce5934"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#d77244"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1z",
    fill: "#e4a365"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v1h-1v-1z",
    fill: "#ebb676"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1z",
    fill: "#ebb677"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#e08c50"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1z",
    fill: "#e06349"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1z",
    fill: "#e96c62"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#e36b61"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#e56a68"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1z",
    fill: "#f38089"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1z",
    fill: "#e55d59",
    fillOpacity: 0.969
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1z",
    fill: "#dc5c51",
    fillOpacity: 0.173
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M18 51v1h-1v-1z",
    fill: "#f8e3c5",
    fillOpacity: 0.643
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52h-1v-1h1z",
    fill: "#fce0c0",
    fillOpacity: 0.961
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M20 51v1h-1v-1z",
    fill: "#ffd2c0"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51v1h-1v-1z",
    fill: "#ffc0ba"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52v-1h1v1z",
    fill: "#fbc5c1"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M23 51v1h-1v-1z",
    fill: "#fab4ad"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h-1v-1h1z",
    fill: "#f79789"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h1v1h-1z",
    fill: "#ec826d"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52h-1v-1h1z",
    fill: "#db694c"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v1h-1v-1z",
    fill: "#cc4f37"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52h-1v-1h1z",
    fill: "#b02e22"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52v-1h1v1z",
    fill: "#ad251d"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v-1h1v1z",
    fill: "#9f1319"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52v-1h1v1z",
    fill: "#900610"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h-1v-1h1z",
    fill: "#930309"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51v1h-1v-1z",
    fill: "#890307"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1z",
    fill: "#770007"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1z",
    fill: "#750006"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M35 51h1v1h-1z",
    fill: "#7f010a"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M37 52h-1v-1h1z",
    fill: "#830009"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M38 51v1h-1v-1z",
    fill: "#830106"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M39 51v1h-1v-1z",
    fill: "#840106"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M39 52v-1h1v1z",
    fill: "#870207"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1z",
    fill: "#8b0003"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#9e170d"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1z",
    fill: "#c56d3f"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M44 51v1h-1v-1z",
    fill: "#dfa764"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52v-1h1v1z",
    fill: "#eaba7e"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52h-1v-1h1z",
    fill: "#ecbf81"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#eabf75"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1z",
    fill: "#e8bf73"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1z",
    fill: "#ecc27d"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#e7ad73"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51v1h-1v-1z",
    fill: "#eab276"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1z",
    fill: "#f3c383"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M52 51h1v1h-1z",
    fill: "#f2c98e"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M54 52h-1v-1h1z",
    fill: "#f2c994"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h1v1h-1z",
    fill: "#edca92"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52h-1v-1h1z",
    fill: "#f4c99c"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h-1v-1h1z",
    fill: "#f4cba7"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1z",
    fill: "#f1bd8d"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52v-1h1v1z",
    fill: "#de814f"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v-1z",
    fill: "#d95538"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1z",
    fill: "#e05c42"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#ee6c5e"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1z",
    fill: "#f3706b"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fill: "#db4f4a",
    fillOpacity: 0.808
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1z",
    fill: "#bfbf7f",
    fillOpacity: 0.016
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52v1h-1v-1z",
    fill: "#fff9e2",
    fillOpacity: 0.173
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53v-1h1v1z",
    fill: "#f8dfc8",
    fillOpacity: 0.443
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M20 52h1v1h-1z",
    fill: "#efb0a5",
    fillOpacity: 0.816
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52h1v1h-1z",
    fill: "#ffbaae"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M22 52h1v1h-1z",
    fill: "#fea99c"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52v1h-1v-1z",
    fill: "#f88b78"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h1v1h-1z",
    fill: "#f07159"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52v1h-1v-1z",
    fill: "#dd6647"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53h-1v-1h1z",
    fill: "#ca4c33"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M27 52h1v1h-1z",
    fill: "#c03628"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v1h-1v-1z",
    fill: "#b3241b"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52h1v1h-1z",
    fill: "#a21319"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M31 52v1h-1v-1z",
    fill: "#91050e"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53h-1v-1h1z",
    fill: "#980408"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h1v1h-1z",
    fill: "#930505"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52v1h-1v-1z",
    fill: "#860205"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1z",
    fill: "#860305"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1z",
    fill: "#8c0204"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1z",
    fill: "#950305"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M38 52v1h-1v-1z",
    fill: "#920203"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v1z",
    fill: "#910201"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53h-1v-1h1z",
    fill: "#930000"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h-1v-1h1z",
    fill: "#ae2418"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1z",
    fill: "#e2a36b"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h1v1z",
    fill: "#eec88c"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1z",
    fill: "#edc48f"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v1h-1z",
    fill: "#f1c599"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#f0c695"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h1v1h-1z",
    fill: "#f1c48d"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h1v1h-1z",
    fill: "#f2c890"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52h1v1h-1z",
    fill: "#f1c890"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1z",
    fill: "#f3ce9a"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52v1h-1v-1z",
    fill: "#f5cc98"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52h1v1h-1z",
    fill: "#f5ca91"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52v1h-1v-1z",
    fill: "#f1c68d"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53v-1h1v1z",
    fill: "#f5ca99"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53h-1v-1h1z",
    fill: "#f4cca1"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1z",
    fill: "#f6cba2"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52h1v1h-1z",
    fill: "#f5ca9d"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v1h-1v-1z",
    fill: "#f0b789"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M61 53h-1v-1h1z",
    fill: "#e39667"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1z",
    fill: "#da5e42",
    fillOpacity: 0.898
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M63 53h-1v-1h1z",
    fill: "#e44c39",
    fillOpacity: 0.969
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M63 52h1v1h-1z",
    fill: "#d7564a",
    fillOpacity: 0.604
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M21 53v1h-1v-1z",
    fill: "#d98d8d",
    fillOpacity: 0.106
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53v1h-1v-1z",
    fill: "#eeae96",
    fillOpacity: 0.471
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53h1v1h-1z",
    fill: "#f6be99",
    fillOpacity: 0.922
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M23 54v-1h1v1z",
    fill: "#ffc096"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54h-1v-1h1z",
    fill: "#ef8360"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54v-1h1v1z",
    fill: "#e7593d"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54h-1v-1h1z",
    fill: "#d4422b"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M28 53v1h-1v-1z",
    fill: "#c93422"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54h-1v-1h1z",
    fill: "#ba251f"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M30 53v1h-1v-1z",
    fill: "#ab171d"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54v-1h1v1z",
    fill: "#9c070e"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M31 53h1v1h-1z",
    fill: "#a50504"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#a30401"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54v-1h1v1z",
    fill: "#9d0103"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1z",
    fill: "#a00306"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53v1h-1v-1z",
    fill: "#a90807"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h1v1h-1z",
    fill: "#ab0505"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v1h-1v-1z",
    fill: "#a60002"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1z",
    fill: "#a70000"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53v1h-1v-1z",
    fill: "#b92a1a"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1z",
    fill: "#ebb187"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h1v1h-1z",
    fill: "#f4d0a1"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#f4cb9d"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1z",
    fill: "#f2cb9c"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53v1h-1v-1z",
    fill: "#f4cba0"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54h-1v-1h1z",
    fill: "#f3ce9e"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1z",
    fill: "#f2c992"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h-1v-1h1z",
    fill: "#f4cb94"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M49 54h-1v-1h1z",
    fill: "#f6ce9f"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h-1v-1z",
    fill: "#f6cc97"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53v1h-1v-1z",
    fill: "#f5cc97"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M51 54v-1h1v1z",
    fill: "#f7d3a5"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h-1v-1h1z",
    fill: "#f5d3a6"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54h-1v-1h1z",
    fill: "#f4d1a6"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54v-1h1v1z",
    fill: "#fad2a4"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53v1h-1v-1z",
    fill: "#f8cd99"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h1z",
    fill: "#f8ce91"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53h1v1h-1z",
    fill: "#f8ce97"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v1h-1z",
    fill: "#fbd1a8"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53h1v1h-1z",
    fill: "#f4d2b1",
    fillOpacity: 0.49
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53v1h-1v-1z",
    fill: "#c99378",
    fillOpacity: 0.075
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1z",
    fill: "#c34135",
    fillOpacity: 0.169
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v1h-1v-1z",
    fill: "#c26d55",
    fillOpacity: 0.165
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55v-1h1v1z",
    fill: "#f1e4c4",
    fillOpacity: 0.153
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54v1h-1v-1z",
    fill: "#f9deba",
    fillOpacity: 0.698
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v-1h1v1z",
    fill: "#ffdaad"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55h-1v-1h1z",
    fill: "#f09965"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54v1h-1v-1z",
    fill: "#d8452a"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M27 55v-1h1v1z",
    fill: "#d1462b"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54v1h-1v-1z",
    fill: "#cc2d1e"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55v-1h1v1z",
    fill: "#b9120f"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54v1h-1v-1z",
    fill: "#a90906"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v1h-1v-1z",
    fill: "#b7180c"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v-1h1v1z",
    fill: "#b3100b"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54h1v1h-1z",
    fill: "#b30c0b"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#ab0000"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1z",
    fill: "#b60200"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#b30200"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1z",
    fill: "#b20100"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v1h-1v-1z",
    fill: "#c01d14"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54h1v1h-1z",
    fill: "#ebac80"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#f3cda0"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M42 55v-1h1v1z",
    fill: "#f5ce9b"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54v1h-1v-1z",
    fill: "#f7cf9a"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55v-1h1v1z",
    fill: "#f7ce9a"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-1z",
    fill: "#f7ce99"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55h-1v-1h1z",
    fill: "#f4cc98"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1z",
    fill: "#f7cf9b"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1z",
    fill: "#f4cd97"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M49 55v-1h1v1z",
    fill: "#f2cd95"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-1z",
    fill: "#f6d19f"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h1v1h-1z",
    fill: "#fbdaaf"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v1h-1v-1z",
    fill: "#f9dabc",
    fillOpacity: 0.855
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54v1h-1v-1z",
    fill: "#f3d8be",
    fillOpacity: 0.341
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55v-1h1v1z",
    fill: "#f6dec0",
    fillOpacity: 0.498
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1z",
    fill: "#f6d7b2",
    fillOpacity: 0.867
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55v-1h1v1z",
    fill: "#ffdfbb"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54v1h-1v-1z",
    fill: "#f5d4b5",
    fillOpacity: 0.733
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55h1v1h-1z",
    fill: "#fddfc0",
    fillOpacity: 0.514
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55v1h-1v-1z",
    fill: "#fbddaf",
    fillOpacity: 0.992
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M26 56v-1h1v1z",
    fill: "#f6c596"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v-1h1v1z",
    fill: "#f8c699"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55h1v1h-1z",
    fill: "#efb088"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55h1v1h-1z",
    fill: "#d76d57"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M31 55v1h-1v-1z",
    fill: "#ce4334"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56h-1v-1h1z",
    fill: "#d22f1d"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#c8251a"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#c6251f"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1z",
    fill: "#d04c3c"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v-1h1v1z",
    fill: "#dc714f"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M37 56h-1v-1h1z",
    fill: "#d95f45"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55v1h-1v-1z",
    fill: "#ce4f39"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M38 56v-1h1v1z",
    fill: "#edb289"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h-1v-1h1z",
    fill: "#f8dbaf"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#f8d3a5"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v1h-1z",
    fill: "#f7d3a0"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-1h1z",
    fill: "#f5d09a"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55h1v1h-1z",
    fill: "#f5cf94"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55h1v1h-1z",
    fill: "#f6ce95"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56v-1h1v1z",
    fill: "#f5cd98"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1z",
    fill: "#f4cc99"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1z",
    fill: "#f4cd98"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1z",
    fill: "#f4cd99"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56h-1v-1h1z",
    fill: "#f7cfa1"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55v1h-1v-1z",
    fill: "#f6d2a4"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55v1h-1v-1z",
    fill: "#fad9b3"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1z",
    fill: "#fde2c3",
    fillOpacity: 0.996
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M55 56h-1v-1h1z",
    fill: "#f8e6d4",
    fillOpacity: 0.329
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55h1v1h-1z",
    fill: "#ebe5d8",
    fillOpacity: 0.157
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1z",
    fill: "#f5ece2",
    fillOpacity: 0.106
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55h1v1h-1z",
    fill: "#f9decc",
    fillOpacity: 0.337
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56h-1v-1h1z",
    fill: "#f8dfcc",
    fillOpacity: 0.157
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M25 56h1v1h-1z",
    fill: "#fbe9c9",
    fillOpacity: 0.502
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v1h-1v-1z",
    fill: "#ffebc3",
    fillOpacity: 0.996
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M28 56h1v1h-1z",
    fill: "#fae5bc"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56v1h-1v-1z",
    fill: "#fceccc"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57v-1h1v1z",
    fill: "#f9dfc0"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M31 56h1v1h-1z",
    fill: "#eba282"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#df795c"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56h1v1h-1z",
    fill: "#edac7f"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v-1h1v1z",
    fill: "#f8d6a1"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56v1h-1v-1z",
    fill: "#f8daa3"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56h1v1h-1z",
    fill: "#f8d7a3"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M38 57h-1v-1h1z",
    fill: "#f7d5a4"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#f6d8a8"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1z",
    fill: "#f8d2a3"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1z",
    fill: "#f6cf9b"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1z",
    fill: "#f8d099"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57h-1v-1h1z",
    fill: "#f6d19a"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#f7d3a6"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M46 56h1v1h-1z",
    fill: "#f5d1a4"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1z",
    fill: "#f3cfa0"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56v1h-1v-1z",
    fill: "#f7d2a5"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57v-1h1v1z",
    fill: "#f6d0a0"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M52 57h-1v-1h1z",
    fill: "#f7d6ad"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1z",
    fill: "#f9dec6",
    fillOpacity: 0.584
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M27 57v1h-1v-1z",
    fill: "#f9eac9",
    fillOpacity: 0.769
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h1v1h-1z",
    fill: "#fde0b4"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M29 57h1v1h-1z",
    fill: "#fde0bb"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v-1h1v1z",
    fill: "#fee2c0"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h1v1z",
    fill: "#ffe2b8"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M33 57v1h-1v-1z",
    fill: "#fcdea6"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v1h-1v-1z",
    fill: "#f9db9b"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58h-1v-1h1z",
    fill: "#f9d49c"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58v-1h1v1z",
    fill: "#f8d3a1"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1z",
    fill: "#f5d3a2"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58h-1v-1h1z",
    fill: "#f7d3a1"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h-1v-1h1z",
    fill: "#f5d1a0"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1z",
    fill: "#f4cf96"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58h-1v-1h1z",
    fill: "#f4d29d"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v-1h1v1z",
    fill: "#f3d1a3"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1z",
    fill: "#f3d1a1"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58h-1v-1h1z",
    fill: "#f3cf9a"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v-1h1v1z",
    fill: "#f3cd90"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1z",
    fill: "#f3ce90"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1z",
    fill: "#f6d2a0"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h-1v-1h1z",
    fill: "#fbdab2"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58v-1h1v1z",
    fill: "#ffe2c1"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h1v1h-1z",
    fill: "#ffe1ce",
    fillOpacity: 0.267
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58v1h-1v-1z",
    fill: "#f9e7c3",
    fillOpacity: 0.506
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58h1v1h-1z",
    fill: "#fff0c1"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59h-1v-1h1z",
    fill: "#fde2b6"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v1h-1v-1z",
    fill: "#fedda9"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59v-1h1v1z",
    fill: "#fdd79c"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M33 58v1h-1v-1z",
    fill: "#fee1b9"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59h-1v-1h1z",
    fill: "#fcdeb0"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59h-1v-1h1z",
    fill: "#f8d7a7"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h-1v-1h1z",
    fill: "#fad7ac"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#f9d7ad"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h-1v-1h1z",
    fill: "#f6d5a8"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1z",
    fill: "#f5d4a5"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1z",
    fill: "#f3d4a0"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1z",
    fill: "#f4d4a3"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#f2d09b"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1z",
    fill: "#f2cd92"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v1h-1v-1z",
    fill: "#f2ca8b"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59v-1h1v1z",
    fill: "#f1c97e"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58h1v1h-1z",
    fill: "#f4cc92"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59v-1h1v1z",
    fill: "#fbd8a8"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h1v1h-1z",
    fill: "#ffe0b6"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58h1v1h-1z",
    fill: "#ffe4ce",
    fillOpacity: 0.451
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M26 59h1v1h-1z",
    fill: "#f9e3c8",
    fillOpacity: 0.184
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M27 60v-1h1v1z",
    fill: "#fbe7b8",
    fillOpacity: 0.878
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59v1h-1v-1z",
    fill: "#ffe7b2"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v-1h1v1z",
    fill: "#fee1ae"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59h1v1h-1z",
    fill: "#fcda9c"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60h-1v-1h1z",
    fill: "#fdd595"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59v1h-1v-1z",
    fill: "#fbdaae"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59v1h-1v-1z",
    fill: "#fad6a6"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M39 59h1v1h-1z",
    fill: "#f8d2a0"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#f7d3a3"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#f7d3a7"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60v-1h1v1z",
    fill: "#f7d1a3"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#f0c77e"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#f3c880"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#f3c985"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1z",
    fill: "#f2c989"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1z",
    fill: "#f8cf8f"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h-1v-1h1z",
    fill: "#fcd38e"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#ffdc9f"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1z",
    fill: "#fce1c2",
    fillOpacity: 0.412
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M28 61h-1v-1h1z",
    fill: "#f8e6c0",
    fillOpacity: 0.161
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v1h-1v-1z",
    fill: "#fbe1a3",
    fillOpacity: 0.925
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h-1v-1h1z",
    fill: "#ffe8b1"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61v-1h1v1z",
    fill: "#fbd693"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61v-1h1v1z",
    fill: "#fbd8a0"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61h-1v-1h1z",
    fill: "#fbd7a6"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60v1h-1v-1z",
    fill: "#f9d398"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1z",
    fill: "#f6d096"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h-1v-1h1z",
    fill: "#f7cf93"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61h-1v-1h1z",
    fill: "#f4cd8b"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61v-1h1v1z",
    fill: "#f3cc89"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#f7cf98"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M43 61h-1v-1h1z",
    fill: "#f7cf9c"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60h1v1h-1z",
    fill: "#f2c680"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#eec167"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#f3c87c"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#f3cc8a"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#f2c878"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#f4ca6b"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61v-1h1v1z",
    fill: "#f7cb79"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61h-1v-1h1z",
    fill: "#fcd182"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M53 61h-1v-1h1z",
    fill: "#fbd79d",
    fillOpacity: 0.984
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1z",
    fill: "#ffebd2",
    fillOpacity: 0.157
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h-1v-1h1z",
    fill: "#f8dfb2",
    fillOpacity: 0.286
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h-1v-1h1z",
    fill: "#fbe3b4",
    fillOpacity: 0.792
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h1v1h-1z",
    fill: "#ffe4b0"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62v-1h1v1z",
    fill: "#fdd591"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61h1v1h-1z",
    fill: "#f7d286"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61v1h-1v-1z",
    fill: "#f7d18c"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h-1v-1h1z",
    fill: "#f8cf89"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M36 61h1v1h-1z",
    fill: "#f7ce89"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62v-1h1v1z",
    fill: "#f8d094"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61h1v1h-1z",
    fill: "#f8d095"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h1v1h-1z",
    fill: "#f4cd88"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M41 61v1h-1v-1z",
    fill: "#f2cb7e"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v1h-1v-1z",
    fill: "#f5cd8d"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M42 62v-1h1v1z",
    fill: "#f4cc90"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#f2cc8b"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#edc36c"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61h1v1h-1z",
    fill: "#efc263"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1z",
    fill: "#f5c882"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#f4cc8c"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62h-1v-1h1z",
    fill: "#f2c970"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1z",
    fill: "#f5cb6a"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61h1v1h-1z",
    fill: "#f6cc76"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#fcd689",
    fillOpacity: 0.996
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#f7dcae",
    fillOpacity: 0.545
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h1v1h-1z",
    fill: "#f7e2b4",
    fillOpacity: 0.282
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h1v1h-1z",
    fill: "#ffe1a4",
    fillOpacity: 0.992
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63h-1v-1h1z",
    fill: "#ffda9a"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62v1h-1v-1z",
    fill: "#fed79c"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62h1v1h-1z",
    fill: "#f9d28e"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M34 62h1v1h-1z",
    fill: "#f8cf82"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v-1h1v1z",
    fill: "#f4ca75"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h1v1h-1z",
    fill: "#f1c86a"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v-1h1v1z",
    fill: "#f2ca77"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h-1v-1h1z",
    fill: "#efc976"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h-1v-1h1z",
    fill: "#f2cc7b"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62v1h-1v-1z",
    fill: "#f0c872"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62h1v1h-1z",
    fill: "#f1c879"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63v-1h1v1z",
    fill: "#f3cb86"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M43 63v-1h1v1z",
    fill: "#f1c87b"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-1v-1h1z",
    fill: "#ebc158"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#eec15a"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#f3c983"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62h1v1h-1z",
    fill: "#f5cb7a"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#f8cb78"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#fdcf7a"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M51 62h1v1h-1z",
    fill: "#f9cf8a",
    fillOpacity: 0.78
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62v1h-1v-1z",
    fill: "#bfffff",
    fillOpacity: 0.016
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M30 63v1h-1v-1z",
    fill: "#ffe3bf",
    fillOpacity: 0.11
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M31 64h-1v-1h1z",
    fill: "#fcd991",
    fillOpacity: 0.949
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63v1h-1v-1z",
    fill: "#ffd783"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64v-1h1v1z",
    fill: "#fdd78a"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64h-1v-1h1z",
    fill: "#fcd591"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v1h-1v-1z",
    fill: "#f7cf80"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64v-1h1v1z",
    fill: "#f5cb6f"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v1h-1v-1z",
    fill: "#f2c765"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63h1v1h-1z",
    fill: "#f2c974"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64v-1h1v1z",
    fill: "#f0c96f"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h1v1h-1z",
    fill: "#f4cb7a"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h1v1h-1z",
    fill: "#eec764"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M41 63h1v1h-1z",
    fill: "#efc86e"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63h1v1h-1z",
    fill: "#f2c87e"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64h-1v-1h1z",
    fill: "#eec35d"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64v-1h1v1z",
    fill: "#eabc40"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#edbd47"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#eabf46"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1z",
    fill: "#f1c771"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M48 63h1v1h-1z",
    fill: "#f7cc7e"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-1z",
    fill: "#f9ca7a"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1z",
    fill: "#ffcf76"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64v-1h1v1z",
    fill: "#f7cb83",
    fillOpacity: 0.682
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M30 64h1v1h-1z",
    fill: "#fcda99",
    fillOpacity: 0.871
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M31 65v-1h1v1z",
    fill: "#ffd888"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64h1v1h-1z",
    fill: "#fdd689"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64v1h-1v-1z",
    fill: "#fdd695"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65v-1h1v1z",
    fill: "#fad38c"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64h1v1h-1z",
    fill: "#f6cc6b"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M36 64h1v1h-1z",
    fill: "#edc249"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v-1h1v1z",
    fill: "#efc55d"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h-1z",
    fill: "#f5c975"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M39 64h1v1h-1z",
    fill: "#f5ca77"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64h1v1h-1z",
    fill: "#ecc154"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M41 65v-1h1v1z",
    fill: "#eec45e"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64h1v1h-1z",
    fill: "#e7bb35"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v-1h1v1z",
    fill: "#ecba38"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M45 64h1v1h-1z",
    fill: "#f2bf56"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h1v1h-1z",
    fill: "#eec259"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64v1h-1v-1z",
    fill: "#f2c468"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h1v1h-1z",
    fill: "#f4c76d"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65h-1v-1h1z",
    fill: "#f6c76b"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h-1v-1h1z",
    fill: "#fecf76"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64h1v1h-1z",
    fill: "#f7cb82",
    fillOpacity: 0.78
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64v1h-1v-1z",
    fill: "#ffbfbf",
    fillOpacity: 0.016
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66v-1h1v1z",
    fill: "#f9dea7",
    fillOpacity: 0.729
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66h-1v-1h1z",
    fill: "#ffdc94"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M32 65h1v1h-1z",
    fill: "#fdd68e"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h-1v-1h1z",
    fill: "#fdd58d"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65h1v1h-1z",
    fill: "#fcd58d"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66v-1h1v1z",
    fill: "#f4cc5f"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v1h-1v-1z",
    fill: "#e5bc24"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M38 66v-1h1v1z",
    fill: "#eec056"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v-1h1v1z",
    fill: "#f4c96b"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66v-1h1v1z",
    fill: "#f2c255"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#eebd4a"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M42 65h1v1h-1z",
    fill: "#f2c053"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v1h-1v-1z",
    fill: "#e8b725"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65h1v1h-1z",
    fill: "#edb833"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66v-1h1v1z",
    fill: "#f3c05a"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66h-1v-1h1z",
    fill: "#f6c36e"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v-1h1v1z",
    fill: "#f4c164"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65h1v1h-1z",
    fill: "#f3c55d"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1z",
    fill: "#f6c667"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66v-1h1v1z",
    fill: "#f9c96c"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h1v1h-1z",
    fill: "#face7e",
    fillOpacity: 0.984
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M53 66h-1v-1h1z",
    fill: "#f6d9ac",
    fillOpacity: 0.243
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66h1v1h-1z",
    fill: "#f3dda7",
    fillOpacity: 0.62
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M31 66h1v1h-1z",
    fill: "#ffe19c"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M32 67v-1h1v1z",
    fill: "#fed484"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66v1h-1v-1z",
    fill: "#fbd380"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h1v1h-1z",
    fill: "#fbd482"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66h1v1h-1z",
    fill: "#f6cb53"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M37 66v1h-1v-1z",
    fill: "#e7b91e"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M37 67v-1h1v1z",
    fill: "#e7bb2a"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v1h-1v-1z",
    fill: "#e1b61b"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67h-1v-1h1z",
    fill: "#e9bf48"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66h1v1h-1z",
    fill: "#efc056"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66v1h-1v-1z",
    fill: "#efbc46"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67v-1h1v1z",
    fill: "#f1bb46"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M44 66v1h-1v-1z",
    fill: "#eab621"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M45 67h-1v-1h1z",
    fill: "#e9b620"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#f2bc4d"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v1h-1v-1z",
    fill: "#f2be56"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M47 67v-1h1v1z",
    fill: "#f5c362"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v-1h1v1z",
    fill: "#f2c563"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67v-1h1v1z",
    fill: "#f5c567"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66h1v1h-1z",
    fill: "#f7c865"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M51 66h1v1h-1z",
    fill: "#ffd17f"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66h1v1h-1z",
    fill: "#f6cf9a",
    fillOpacity: 0.337
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67h1v1h-1z",
    fill: "#f7e1bb",
    fillOpacity: 0.133
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68h-1v-1h1z",
    fill: "#fbd896",
    fillOpacity: 0.894
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M33 67v1h-1v-1z",
    fill: "#ffda89"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M33 68v-1h1v1z",
    fill: "#fcd583"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M34 67h1v1h-1z",
    fill: "#fbd177"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v-1h1v1z",
    fill: "#f5c74d"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M36 67h1v1h-1z",
    fill: "#eab92a"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M38 67v1h-1v-1z",
    fill: "#e5b822"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v-1h1v1z",
    fill: "#deb408"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M39 67h1v1h-1z",
    fill: "#e8bc38"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68v-1h1v1z",
    fill: "#f2c364"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M41 67h1v1h-1z",
    fill: "#efbf54"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67v1h-1v-1z",
    fill: "#f0bb48"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67h1v1h-1z",
    fill: "#e7b51b"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1z",
    fill: "#e6b515"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1z",
    fill: "#efb836"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1z",
    fill: "#f2bf50"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v1h-1v-1z",
    fill: "#f4c35d"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67h1v1h-1z",
    fill: "#f1c45a"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h1v1h-1z",
    fill: "#f6c35d"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-1h1v1z",
    fill: "#f8c658"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1z",
    fill: "#fbce7e",
    fillOpacity: 0.992
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68h-1v-1h1z",
    fill: "#f1cea4",
    fillOpacity: 0.286
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69v-1h1v1z",
    fill: "#fbefcf",
    fillOpacity: 0.318
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68v1h-1v-1z",
    fill: "#fcdd9a",
    fillOpacity: 0.957
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69v-1h1v1z",
    fill: "#ffd98c"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v-1h1v1z",
    fill: "#fad383"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v1h-1v-1z",
    fill: "#face6d"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68h1v1h-1z",
    fill: "#f2c542"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M37 69h-1v-1h1z",
    fill: "#ecbc38"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v1h-1v-1z",
    fill: "#e8b925"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M38 69v-1h1v1z",
    fill: "#dfb408"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69v-1h1v1z",
    fill: "#e7ba35"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69h-1v-1h1z",
    fill: "#f2c263"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#efc156"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1z",
    fill: "#eebd4f"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68v1h-1v-1z",
    fill: "#e7b822"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1z",
    fill: "#e7b516"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#eab627"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M47 68v1h-1v-1z",
    fill: "#f3c04e"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h-1v-1h1z",
    fill: "#f3c161"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1z",
    fill: "#f1c254"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v1h-1v-1z",
    fill: "#f1c147"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1z",
    fill: "#f8c853"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h-1v-1h1z",
    fill: "#f7ca70",
    fillOpacity: 0.89
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68h1v1h-1z",
    fill: "#dca",
    fillOpacity: 0.059
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69h1v1h-1z",
    fill: "#fbe9cc",
    fillOpacity: 0.275
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M31 70v-1h1v1z",
    fill: "#ffde9f"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v1h-1v-1z",
    fill: "#fed685"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69v1h-1v-1z",
    fill: "#fedb92"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70h-1v-1h1z",
    fill: "#f9cd6c"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M36 69v1h-1v-1z",
    fill: "#f2bf46"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70v-1h1v1z",
    fill: "#eebf30"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70v-1h1v1z",
    fill: "#e8b91d"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M39 70h-1v-1h1z",
    fill: "#dfb404"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69h1v1h-1z",
    fill: "#e1b61c"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69v1h-1v-1z",
    fill: "#ecbc48"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#ebba45"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69v1h-1v-1z",
    fill: "#eebb41"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69h1v1h-1z",
    fill: "#e8b622"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1z",
    fill: "#e5b411"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1z",
    fill: "#e6b415"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70v-1h1v1z",
    fill: "#f1bf4e"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v1h-1v-1z",
    fill: "#f5c367"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h1v1h-1z",
    fill: "#f5c35d"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70h-1v-1h1z",
    fill: "#f0c14a"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v1h-1z",
    fill: "#f6c654"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69h1v1h-1z",
    fill: "#faca67",
    fillOpacity: 0.976
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M53 69v1h-1v-1z",
    fill: "#f0ce83",
    fillOpacity: 0.267
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71v-1h1v1z",
    fill: "#f9e4bf",
    fillOpacity: 0.38
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h-1v-1h1z",
    fill: "#fedd97"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M33 70v1h-1v-1z",
    fill: "#fed782"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71v-1h1v1z",
    fill: "#fbd684"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70v1h-1v-1z",
    fill: "#f7cb6a"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71v-1h1v1z",
    fill: "#f6c153"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70h1v1h-1z",
    fill: "#f2bf3d"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70h1v1h-1z",
    fill: "#e8ba1a"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71v-1h1v1z",
    fill: "#dfb602"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70v1h-1v-1z",
    fill: "#d9b303"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M41 71h-1v-1h1z",
    fill: "#e6b732"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71h-1v-1h1z",
    fill: "#ecb940"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M42 70h1v1h-1z",
    fill: "#ecb836"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70h1v1h-1z",
    fill: "#e2b210"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1z",
    fill: "#e0b207"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h1v1z",
    fill: "#e8b51e"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70h1v1h-1z",
    fill: "#eebc45"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h-1v-1h1z",
    fill: "#f2c05a"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M49 71h-1v-1h1z",
    fill: "#efc155"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70v1h-1v-1z",
    fill: "#edc14d"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71v-1h1v1z",
    fill: "#f3c350"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71v-1h1v1z",
    fill: "#facc5f"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v1h-1v-1z",
    fill: "#f7d597",
    fillOpacity: 0.839
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71h-1v-1h1z",
    fill: "#ead6ad",
    fillOpacity: 0.098
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71h1v1h-1z",
    fill: "#eed",
    fillOpacity: 0.059
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h-1v-1h1z",
    fill: "#fff4df",
    fillOpacity: 0.569
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h1v1h-1z",
    fill: "#fceabf",
    fillOpacity: 0.965
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71v1h-1v-1z",
    fill: "#feda91"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h1v1h-1z",
    fill: "#fed88a"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71h1v1h-1z",
    fill: "#f9d180"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M35 72h-1v-1h1z",
    fill: "#f7cb66"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71h1v1h-1z",
    fill: "#f1be40"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M37 71v1h-1v-1z",
    fill: "#eebb32"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v-1h1v1z",
    fill: "#e7ba1e"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71v1h-1v-1z",
    fill: "#e0b608"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71h1v1h-1z",
    fill: "#dab001"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h-1v-1h1z",
    fill: "#e3b524"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71v1h-1v-1z",
    fill: "#e8b738"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M42 72v-1h1v1z",
    fill: "#ecb73f"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71v1h-1v-1z",
    fill: "#e8b728"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1z",
    fill: "#dbb004"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h1v1h-1z",
    fill: "#e1b006"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M47 71v1h-1v-1z",
    fill: "#edba39"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71v1h-1v-1z",
    fill: "#f2c061"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h1v1h-1z",
    fill: "#f2c561"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1z",
    fill: "#f1c459"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71h1v1h-1z",
    fill: "#f4c55a"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M52 71v1h-1v-1z",
    fill: "#f6c861"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71v1h-1v-1z",
    fill: "#ffe09b"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71h1v1h-1z",
    fill: "#f4d7a9",
    fillOpacity: 0.584
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M29 72v1h-1v-1z",
    fill: "#f7f0d7",
    fillOpacity: 0.408
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73h-1v-1h1z",
    fill: "#ffffe7"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h1v1h-1z",
    fill: "#fee4ac"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73h-1v-1h1z",
    fill: "#fdda93"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73h-1v-1h1z",
    fill: "#fedc98"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M34 72v1h-1v-1z",
    fill: "#fedc94"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73h-1v-1h1z",
    fill: "#fad07c"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72v1h-1v-1z",
    fill: "#f1c04f"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72h1v1h-1z",
    fill: "#e8b72b"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72h1v1h-1z",
    fill: "#e5b921"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v-1h1v1z",
    fill: "#ddb611"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M39 72h1v1h-1z",
    fill: "#dcb208"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73v-1h1v1z",
    fill: "#e4b62c"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h1v1h-1z",
    fill: "#e8bb3d"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73h-1v-1h1z",
    fill: "#e7b735"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73v-1h1v1z",
    fill: "#eab734"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72h1v1h-1z",
    fill: "#e0b316"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73v-1h1v1z",
    fill: "#e1b000"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-1v-1z",
    fill: "#e6b526"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v-1h1v1z",
    fill: "#eec15b"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72v1h-1v-1z",
    fill: "#f4c769"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72v1h-1v-1z",
    fill: "#f4c464"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73h-1v-1h1z",
    fill: "#f6c45e"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1z",
    fill: "#f7c764"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73h-1v-1h1z",
    fill: "#ffd587"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1z",
    fill: "#fbd99f",
    fillOpacity: 0.925
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72v1h-1v-1z",
    fill: "#f1dfc3",
    fillOpacity: 0.286
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M28 73h1v1h-1z",
    fill: "#f5ebd7",
    fillOpacity: 0.102
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73v1h-1v-1z",
    fill: "#fdf0d8",
    fillOpacity: 0.569
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74v-1h1v1z",
    fill: "#fde0a5",
    fillOpacity: 0.996
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h-1v-1h1z",
    fill: "#fede9d"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73v1h-1v-1z",
    fill: "#fcdf9e"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M33 74v-1h1v1z",
    fill: "#fdde93"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73v1h-1v-1z",
    fill: "#fdd58b"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74v-1h1v1z",
    fill: "#f8c663"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M36 73h1v1h-1z",
    fill: "#ebbd3b"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v1h-1v-1z",
    fill: "#e4b931"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M39 73v1h-1v-1z",
    fill: "#deb928"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74v-1h1v1z",
    fill: "#dfb728"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73h1v1h-1z",
    fill: "#e7bc49"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M42 73v1h-1v-1z",
    fill: "#e9bf51"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h-1v-1h1z",
    fill: "#e9bb42"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74h-1v-1h1z",
    fill: "#ebb73c"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74v-1h1v1z",
    fill: "#eab833"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1z",
    fill: "#e5b312"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v1h-1v-1z",
    fill: "#e9b72d"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1z",
    fill: "#f0c25b"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73v1h-1v-1z",
    fill: "#f1c661"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h1v1z",
    fill: "#f1c358"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1z",
    fill: "#f5c255"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1z",
    fill: "#f9c75f"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h-1v-1h1z",
    fill: "#f8ca68"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M54 73v1h-1v-1z",
    fill: "#ffde95"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74h-1v-1h1z",
    fill: "#f8deb8",
    fillOpacity: 0.592
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M29 75v-1h1v1z",
    fill: "#f8ecbc",
    fillOpacity: 0.165
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74h1v1h-1z",
    fill: "#fbe0a5",
    fillOpacity: 0.988
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74v1h-1v-1z",
    fill: "#ffe2aa"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h1v1h-1z",
    fill: "#fedfa2"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74v1h-1v-1z",
    fill: "#fedc95"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74h1v1h-1z",
    fill: "#fcd67f"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74h1v1h-1z",
    fill: "#f6c450"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75v-1h1v1z",
    fill: "#edbf3d"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M38 75h-1v-1h1z",
    fill: "#e5bc3e"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M39 75h-1v-1h1z",
    fill: "#e1ba3b"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74h1v1h-1z",
    fill: "#e9be4f"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M41 74v1h-1v-1z",
    fill: "#f0c468"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M42 74v1h-1v-1z",
    fill: "#efc265"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74v1h-1v-1z",
    fill: "#edbe4f"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#e8b837"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75h-1v-1h1z",
    fill: "#e7b82e"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1z",
    fill: "#e3b40e"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v1h-1z",
    fill: "#e9b623"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74v1h-1v-1z",
    fill: "#f1c154"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h1v1h-1z",
    fill: "#f3c765"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74h1v1h-1z",
    fill: "#f2c45e"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v-1h1v1z",
    fill: "#f7c55c"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h-1v-1h1z",
    fill: "#f7c55b"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75v-1h1v1z",
    fill: "#f8c963"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1z",
    fill: "#ffd57e"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1z",
    fill: "#f9dcab",
    fillOpacity: 0.686
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M30 75v1h-1v-1z",
    fill: "#fbe9c6",
    fillOpacity: 0.282
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M31 76h-1v-1h1z",
    fill: "#fde7b2"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M31 75h1v1h-1z",
    fill: "#ffe5b3"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h-1v-1h1z",
    fill: "#ffdea3"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M34 76h-1v-1h1z",
    fill: "#fedd99"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M35 75v1h-1v-1z",
    fill: "#f8d070"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v-1h1v1z",
    fill: "#f5c648"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M36 76v-1h1v1z",
    fill: "#eabb2b"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M37 75h1v1h-1z",
    fill: "#e5ba34"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h-1v-1h1z",
    fill: "#e3bc45"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M40 75v1h-1v-1z",
    fill: "#e8c05d"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76v-1h1v1z",
    fill: "#f1c574"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M41 76v-1h1v1z",
    fill: "#f2c575"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M43 76h-1v-1h1z",
    fill: "#edbf54"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75h1v1h-1z",
    fill: "#e8ba41"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75v1h-1v-1z",
    fill: "#e4b82a"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M46 76h-1v-1h1z",
    fill: "#deb303"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M47 76h-1v-1h1z",
    fill: "#e2b50e"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M48 75v1h-1v-1z",
    fill: "#efc14b"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76h-1v-1h1z",
    fill: "#f3c467"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v1h-1v-1z",
    fill: "#f3c566"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1z",
    fill: "#f4c55e"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1z",
    fill: "#f5c658"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1z",
    fill: "#fbcd7d"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M53 76v-1h1v1z",
    fill: "#ffdb95"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M55 76h-1v-1h1z",
    fill: "#f8dbaf",
    fillOpacity: 0.733
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v-1h1v1z",
    fill: "#fbe9bf",
    fillOpacity: 0.647
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M30 76h1v1h-1z",
    fill: "#fff1c2"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M32 76v1h-1v-1z",
    fill: "#fee8b8"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76v1h-1v-1z",
    fill: "#ffde9a"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h1v1h-1z",
    fill: "#fddb91"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#facd71"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76h1v1h-1z",
    fill: "#facc58"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v-1h1v1z",
    fill: "#ebbc2a"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v-1h1v1z",
    fill: "#e8ba37"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77h-1v-1h1z",
    fill: "#e7bf55"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h1v1h-1z",
    fill: "#ebc873"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76h1v1h-1z",
    fill: "#f4d191"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77v-1h1v1z",
    fill: "#f8d293"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1z",
    fill: "#efc467"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#ecbe52"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#deb40a"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#e1b610"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1z",
    fill: "#efc147"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76v1h-1v-1z",
    fill: "#f3c35e"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77v-1h1v1z",
    fill: "#f4c767"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76h1v1h-1z",
    fill: "#f5c65e"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76h1v1h-1z",
    fill: "#f5c556"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M52 76h1v1h-1z",
    fill: "#f9cc7c"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77v-1h1v1z",
    fill: "#fed694"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M54 77v-1h1v1z",
    fill: "#fde0b6",
    fillOpacity: 0.98
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1z",
    fill: "#fff2da",
    fillOpacity: 0.722
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M56 77v-1h1v1z",
    fill: "#faeee2",
    fillOpacity: 0.243
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78h-1v-1h1z",
    fill: "#fbe7ba",
    fillOpacity: 0.894
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78v-1h1v1z",
    fill: "#fff0c0"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78h-1v-1h1z",
    fill: "#fde7ae"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v-1h1v1z",
    fill: "#fede96"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M34 77v1h-1v-1z",
    fill: "#fddd94"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78h-1v-1h1z",
    fill: "#fcd380"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v1h-1v-1z",
    fill: "#fcce60"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v1h-1v-1z",
    fill: "#f0c236"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M38 77v1h-1v-1z",
    fill: "#edc045"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v-1h1v1z",
    fill: "#efc468"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M40 77v1h-1v-1z",
    fill: "#f2cd8a"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M40 78v-1h1v1z",
    fill: "#f6d49e"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v1h-1v-1z",
    fill: "#f9d59a"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77h1v1h-1z",
    fill: "#f0c66c"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M43 77h1v1h-1z",
    fill: "#f0c461"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77v1h-1v-1z",
    fill: "#edc04c"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v-1h1v1z",
    fill: "#e3b721"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#e3b91e"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77v1h-1v-1z",
    fill: "#eec044"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M49 78h-1v-1h1z",
    fill: "#f4c45e"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1z",
    fill: "#f9cc7b"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M50 78v-1h1v1z",
    fill: "#fbcc81"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1z",
    fill: "#f7cc77"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v-1h1v1z",
    fill: "#facf7e"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77h1v1h-1z",
    fill: "#fdd48d"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M55 78v-1h1v1z",
    fill: "#fff8d7"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M57 77v1h-1v-1z",
    fill: "#faecdb",
    fillOpacity: 0.424
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79h-1v-1h1z",
    fill: "#f7e9bf",
    fillOpacity: 0.427
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M30 79h-1v-1h1z",
    fill: "#feedba"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79h-1v-1h1z",
    fill: "#ffedbf"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v1h-1v-1z",
    fill: "#fde2a3"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M33 78v1h-1v-1z",
    fill: "#fdde8e"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79v-1h1v1z",
    fill: "#fcde9c"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78v1h-1v-1z",
    fill: "#fbd47b"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M35 79v-1h1v1z",
    fill: "#f9ce63"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M37 79h-1v-1h1z",
    fill: "#f4c855"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v1h-1v-1z",
    fill: "#f0c75a"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78v1h-1v-1z",
    fill: "#f3cb7c"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78h1v1h-1z",
    fill: "#f6cf93"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M40 79v-1h1v1z",
    fill: "#f8d193"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78h1v1h-1z",
    fill: "#f8d288"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78v1h-1v-1z",
    fill: "#f2ca73"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78h1v1h-1z",
    fill: "#f5ce7f"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v1h-1v-1z",
    fill: "#edc461"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v1h-1z",
    fill: "#e4bb37"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v1h-1v-1z",
    fill: "#e4bd2f"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1z",
    fill: "#eac038"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1z",
    fill: "#efc347"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M50 79h-1v-1h1z",
    fill: "#f8cb77"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M51 79h-1v-1h1z",
    fill: "#f8cc82"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M52 79h-1v-1h1z",
    fill: "#facf8f"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79h-1v-1h1z",
    fill: "#fbd084"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M54 78v1h-1v-1z",
    fill: "#fad38a"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79v-1h1v1z",
    fill: "#ffdfab"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79h-1v-1h1z",
    fill: "#fceac9",
    fillOpacity: 0.98
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-1h1v1z",
    fill: "#f1f1e4",
    fillOpacity: 0.153
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M27 79h1v1h-1z",
    fill: "#faeecc",
    fillOpacity: 0.42
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79v1h-1v-1z",
    fill: "#fdedc0",
    fillOpacity: 0.969
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h-1v-1h1z",
    fill: "#ffeab5"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79v1h-1v-1z",
    fill: "#feecc5"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M31 80v-1h1v1z",
    fill: "#fde6b2"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79h1v1h-1z",
    fill: "#fee09d"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79h1v1h-1z",
    fill: "#fddd9b"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80v-1h1v1z",
    fill: "#fbcf73"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80h-1v-1h1z",
    fill: "#fbcf61"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80v-1h1v1z",
    fill: "#f7cc5e"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M37 80v-1h1v1z",
    fill: "#f2c962"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M38 79h1v1h-1z",
    fill: "#f4ce84"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M39 79h1v1h-1z",
    fill: "#f6d090"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79v1h-1v-1z",
    fill: "#f5cf83"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79h1v1h-1z",
    fill: "#f2ce70"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-1v-1z",
    fill: "#f3ce78"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79v1h-1v-1z",
    fill: "#efc76b"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79h1v1h-1z",
    fill: "#e6be3b"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M47 80h-1v-1h1z",
    fill: "#e4be37"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M47 79h1v1h-1z",
    fill: "#e1bc20"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M49 79v1h-1v-1z",
    fill: "#ebc249"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M49 80v-1h1v1z",
    fill: "#f3c760"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80v-1h1v1z",
    fill: "#f8c96f"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M52 80h-1v-1h1z",
    fill: "#facd7f"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79v1h-1v-1z",
    fill: "#fcd085"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-1v-1h1z",
    fill: "#fbe9cc",
    fillOpacity: 0.651
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1z",
    fill: "#fceeda",
    fillOpacity: 0.357
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1z",
    fill: "#fbefd8",
    fillOpacity: 0.263
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79v1h-1v-1z",
    fill: "#f9e7ce",
    fillOpacity: 0.518
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80v-1h1v1z",
    fill: "#faebcd",
    fillOpacity: 0.651
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80h-1v-1h1z",
    fill: "#f5ecd9",
    fillOpacity: 0.106
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M24 80h1v1h-1z",
    fill: "#d26666",
    fillOpacity: 0.157
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M25 80h1v1h-1z",
    fill: "#d79393",
    fillOpacity: 0.102
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M27 80v1h-1v-1z",
    fill: "#fae0ce",
    fillOpacity: 0.431
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M27 81v-1h1v1z",
    fill: "#fdf1d2",
    fillOpacity: 0.973
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M28 80h1v1h-1z",
    fill: "#ffebb9"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80v1h-1v-1z",
    fill: "#fde9b9"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h1v1h-1z",
    fill: "#fdecc3"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80v1h-1v-1z",
    fill: "#fce5b2"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80h1v1h-1z",
    fill: "#fedd9b"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-1h1z",
    fill: "#fed683"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M35 80v1h-1v-1z",
    fill: "#fed170"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v-1h1v1z",
    fill: "#facc60"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M37 81h-1v-1h1z",
    fill: "#f2c855"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M38 80v1h-1v-1z",
    fill: "#f3cb6a"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M38 81v-1h1v1z",
    fill: "#f4cf84"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80v1h-1v-1z",
    fill: "#f4cd89"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81v-1h1v1z",
    fill: "#f1cc82"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M41 81v-1h1v1z",
    fill: "#edca6e"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81h-1v-1h1z",
    fill: "#f1cc74"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81v-1h1v1z",
    fill: "#f8d396"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M45 80v1h-1v-1z",
    fill: "#f1cc7b"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81v-1h1v1z",
    fill: "#e3bd3c"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81h-1v-1h1z",
    fill: "#e3bd38"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81v-1h1v1z",
    fill: "#e1be2f"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M49 81h-1v-1h1z",
    fill: "#edc55f"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81h-1v-1h1z",
    fill: "#f2c562"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81v-1h1v1z",
    fill: "#f8c76f"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81h-1v-1h1z",
    fill: "#f9cd78"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81v-1h1v1z",
    fill: "#f8cf7b"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81h-1v-1h1z",
    fill: "#fdd28f"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#ffeecd"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#feebcb"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#ffefcd"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#fff5d1"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80v1h-1v-1z",
    fill: "#fae4ca",
    fillOpacity: 0.608
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80h1v1h-1z",
    fill: "#ef8f6c",
    fillOpacity: 0.314
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h-1v-1h1z",
    fill: "#e76a42",
    fillOpacity: 0.6
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M65 80h1v1h-1z",
    fill: "#db6a55",
    fillOpacity: 0.141
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82h-1v-1h1z",
    fill: "#e06444",
    fillOpacity: 0.757
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82v-1h1v1z",
    fill: "#ee875c",
    fillOpacity: 0.898
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M26 82v-1h1v1z",
    fill: "#ffe3be"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M28 82h-1v-1h1z",
    fill: "#fff3d0"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M28 81h1v1h-1z",
    fill: "#feeab8"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M29 82v-1h1v1z",
    fill: "#ffeec8"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M32 82h-1v-1h1z",
    fill: "#fdda9e"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M33 81v1h-1v-1z",
    fill: "#fdd78c"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81v1h-1v-1z",
    fill: "#fed376"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v1h-1v-1z",
    fill: "#fccd64"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M36 81v1h-1v-1z",
    fill: "#fbcd5e"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h-1v-1h1z",
    fill: "#f2c955"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82h-1v-1h1z",
    fill: "#f2cd6b"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h-1v-1h1z",
    fill: "#f1cd7b"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82v-1h1v1z",
    fill: "#f2cc7f"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81h1v1h-1z",
    fill: "#f3ce86"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82v-1h1v1z",
    fill: "#f2d186"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1z",
    fill: "#f6d490"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1z",
    fill: "#f6d393"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M44 82v-1h1v1z",
    fill: "#f7d496"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81h1v1h-1z",
    fill: "#e5c24d"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#e1bd3b"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h-1v-1h1z",
    fill: "#e6c048"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M48 81h1v1h-1z",
    fill: "#ecc465"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82h-1v-1h1z",
    fill: "#f0c55f"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M51 81v1h-1v-1z",
    fill: "#f3ca6d"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M51 82v-1h1v1z",
    fill: "#f7cf85"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M53 82h-1v-1h1z",
    fill: "#fad186"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81v1h-1v-1z",
    fill: "#fbd28b"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82v-1h1v1z",
    fill: "#fbd798"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#ffe0b3"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M59 82v-1h1v1z",
    fill: "#fde6bf"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h-1v-1h1z",
    fill: "#fbe5c5",
    fillOpacity: 0.953
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M63 82h-1v-1h1z",
    fill: "#f8d0af",
    fillOpacity: 0.733
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#f9a568"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81v1h-1v-1z",
    fill: "#ff8b44"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81v1h-1v-1z",
    fill: "#e36733",
    fillOpacity: 0.753
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h-1v-1h1z",
    fill: "#bf3f3f",
    fillOpacity: 0.031
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82v1h-1v-1z",
    fill: "#dc8568",
    fillOpacity: 0.173
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82h1v1h-1z",
    fill: "#ec723c",
    fillOpacity: 0.961
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83h-1v-1h1z",
    fill: "#f79e61"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83v-1h1v1z",
    fill: "#fdeec5"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M27 82h1v1h-1z",
    fill: "#ffefc9"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v-1h1v1z",
    fill: "#fdecc2"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M29 83v-1h1v1z",
    fill: "#fdecc7"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82v1h-1v-1z",
    fill: "#fde1af"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h1v1h-1z",
    fill: "#ffd795"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M33 82v1h-1v-1z",
    fill: "#ffd889"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M33 83v-1h1v1z",
    fill: "#fed274"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M35 83h-1v-1h1z",
    fill: "#f9cc60"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M36 82v1h-1v-1z",
    fill: "#f8ca61"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82v1h-1v-1z",
    fill: "#f5cd69"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h1v1h-1z",
    fill: "#f2cd76"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83v-1h1v1z",
    fill: "#f1cc7c"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h1v1h-1z",
    fill: "#f3cd82"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M41 83h-1v-1h1z",
    fill: "#f5cf8c"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v1h-1v-1z",
    fill: "#f5d699"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82h1v1h-1z",
    fill: "#f8daa7"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1z",
    fill: "#f5d498"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82v1h-1v-1z",
    fill: "#fbdba5"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82h1v1h-1z",
    fill: "#efcb77"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M47 83h-1v-1h1z",
    fill: "#e1bc3f"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M48 83h-1v-1h1z",
    fill: "#e4bd43"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h1v1h-1z",
    fill: "#eac15e"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#edc460"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83v-1h1v1z",
    fill: "#f1cb74"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M52 82v1h-1v-1z",
    fill: "#fad597"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83v-1h1v1z",
    fill: "#fad499"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M53 83v-1h1v1z",
    fill: "#fad596"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82h1v1h-1z",
    fill: "#fcd8a2"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M55 82h1v1h-1z",
    fill: "#ffe0b2"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h1v1h-1z",
    fill: "#ffe1ba"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#fedeae"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#fedfb2"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M61 82h1v1h-1z",
    fill: "#ffe8c3"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1z",
    fill: "#ffe2bc"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83v-1h1v1z",
    fill: "#f6b879"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M64 83v-1h1v1z",
    fill: "#f3a759"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83h-1v-1h1z",
    fill: "#ef7f33"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82h1v1h-1z",
    fill: "#d96e48",
    fillOpacity: 0.345
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M23 83v1h-1v-1z",
    fill: "#c15b47",
    fillOpacity: 0.098
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v-1h1v1z",
    fill: "#dc5e37",
    fillOpacity: 0.812
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M24 83h1v1h-1z",
    fill: "#f19052"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M27 83v1h-1v-1z",
    fill: "#fdf0d0"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v1h-1v-1z",
    fill: "#feefcc"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84h-1v-1h1z",
    fill: "#fef0d0"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83v1h-1v-1z",
    fill: "#fde7bb"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83h1v1h-1z",
    fill: "#fedda4"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M32 83v1h-1v-1z",
    fill: "#fedb99"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84v-1h1v1z",
    fill: "#fed786"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M33 84v-1h1v1z",
    fill: "#fbd074"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h-1v-1h1z",
    fill: "#f9ce6b"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84v-1h1v1z",
    fill: "#f8cc6e"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84h-1v-1h1z",
    fill: "#f7cf79"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84v-1h1v1z",
    fill: "#f4d07a"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v-1h1v1z",
    fill: "#f2cd7a"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84v-1h1v1z",
    fill: "#f4cf82"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h-1v-1h1z",
    fill: "#f6d292"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83v1h-1v-1z",
    fill: "#f9daa8"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83h1v1h-1z",
    fill: "#fcddb2"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M45 84h-1v-1h1z",
    fill: "#f8d69b"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83h1v1h-1z",
    fill: "#eec870"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M46 84v-1h1v1z",
    fill: "#e4be4c"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M47 84v-1h1v1z",
    fill: "#e2bc3f"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v-1h1v1z",
    fill: "#e7c051"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83h1v1h-1z",
    fill: "#e9c362"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83h1v1h-1z",
    fill: "#f0c879"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M51 83h1v1h-1z",
    fill: "#f5d094"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83h1v1h-1z",
    fill: "#f8d39f"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v-1h1v1z",
    fill: "#fad6a4"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84v-1h1v1z",
    fill: "#fedfb3"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83v1h-1v-1z",
    fill: "#fee4ba"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83h1v1h-1z",
    fill: "#ffe2be"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1z",
    fill: "#fee4c3"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84h-1v-1h1z",
    fill: "#fee2ba"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M62 83h1v1h-1z",
    fill: "#fce0ba"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83h1v1h-1z",
    fill: "#fcdbb5"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M65 84h-1v-1h1z",
    fill: "#face9f"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1z",
    fill: "#fcc38d"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84v-1h1v1z",
    fill: "#f1c59d",
    fillOpacity: 0.831
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#e7c8b1",
    fillOpacity: 0.129
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M21 84h1v1h-1z",
    fill: "#c66",
    fillOpacity: 0.078
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v1h-1v-1z",
    fill: "#eca17c",
    fillOpacity: 0.482
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84h1v1h-1z",
    fill: "#feb082"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M25 84v1h-1v-1z",
    fill: "#fddeb6"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84v1h-1v-1z",
    fill: "#fef0cc"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M26 85v-1h1v1z",
    fill: "#fdedc8"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84v1h-1v-1z",
    fill: "#feeed1"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84v1h-1v-1z",
    fill: "#fde4b9"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84h1v1h-1z",
    fill: "#fddfa8"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85h-1v-1h1z",
    fill: "#fedc99"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84h1v1h-1z",
    fill: "#fdd68a"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84v1h-1v-1z",
    fill: "#fad27e"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84h1v1h-1z",
    fill: "#f8cf7c"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h1v1h-1z",
    fill: "#f8ce7b"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M36 85v-1h1v1z",
    fill: "#facf82"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v1h-1v-1z",
    fill: "#f4cd78"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84h1v1h-1z",
    fill: "#f2cb78"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84v1h-1v-1z",
    fill: "#f6d497"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h1v1h-1z",
    fill: "#fadcac"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84v1h-1v-1z",
    fill: "#fee2b8"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84h1v1h-1z",
    fill: "#f8dba9"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85h-1v-1h1z",
    fill: "#f6d290"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85h-1v-1h1z",
    fill: "#eec466"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M47 85h-1v-1h1z",
    fill: "#e9c160"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v1h-1v-1z",
    fill: "#e4bf54"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85v-1h1v1z",
    fill: "#e5c158"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85h-1v-1h1z",
    fill: "#e8c468"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M50 84h1v1h-1z",
    fill: "#f1c982"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M51 84h1v1h-1z",
    fill: "#f4cf95"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M53 85h-1v-1h1z",
    fill: "#f4d296"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84h1v1h-1z",
    fill: "#f6d39d"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85v-1h1v1z",
    fill: "#fbd9a9"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84h1v1h-1z",
    fill: "#fedeb5"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84h1v1h-1z",
    fill: "#fee2c2"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M58 84v1h-1v-1z",
    fill: "#ffe5c7"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M60 85h-1v-1h1z",
    fill: "#fee1b7"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M61 85h-1v-1h1z",
    fill: "#fee4be"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84v1h-1v-1z",
    fill: "#fedfb5"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85v-1h1v1z",
    fill: "#fdddb0"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v-1h1v1z",
    fill: "#fedaad"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M66 85h-1v-1h1z",
    fill: "#fed7ad"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84h1v1h-1z",
    fill: "#ffdfb7"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v-1h1v1z",
    fill: "#ecceaa",
    fillOpacity: 0.694
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84h1v1h-1z",
    fill: "#bf7f7f",
    fillOpacity: 0.016
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85v1h-1v-1z",
    fill: "#d98484",
    fillOpacity: 0.106
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M20 86h-1v-1h1z",
    fill: "#e36e5c",
    fillOpacity: 0.4
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M20 85h1v1h-1z",
    fill: "#df6d4e",
    fillOpacity: 0.659
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M21 86v-1h1v1z",
    fill: "#e8916c",
    fillOpacity: 0.886
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86h-1v-1h1z",
    fill: "#fad4b4",
    fillOpacity: 0.957
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M24 86v-1h1v1z",
    fill: "#fdeec9"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M25 85h1v1h-1z",
    fill: "#feebc5"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h-1v-1h1z",
    fill: "#fef0cb"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M30 85v1h-1v-1z",
    fill: "#ffeac1"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M30 86v-1h1v1z",
    fill: "#fee3b6"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85v1h-1v-1z",
    fill: "#fddda2"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M33 85v1h-1v-1z",
    fill: "#fcd592"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M34 86h-1v-1h1z",
    fill: "#fad28b"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h-1v-1h1z",
    fill: "#f9d28d"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M35 85h1v1h-1z",
    fill: "#f5ce82"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M37 86h-1v-1h1z",
    fill: "#f6ce7d"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M38 85v1h-1v-1z",
    fill: "#f1c96c"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M38 86v-1h1v1z",
    fill: "#f3ca75"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86h-1v-1h1z",
    fill: "#f7d08d"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v1z",
    fill: "#fad7a0"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#fcdeac"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M44 86h-1v-1h1z",
    fill: "#faddb4"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85v1h-1v-1z",
    fill: "#efc572"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h-1v-1h1z",
    fill: "#edc26d"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-1h1z",
    fill: "#e7c26a"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85h1v1h-1z",
    fill: "#e6c168"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85v1h-1v-1z",
    fill: "#ebc572"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h-1v-1h1z",
    fill: "#eec780"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86v-1h1v1z",
    fill: "#f2cd8f"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86v-1h1v1z",
    fill: "#f5d29c"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86h-1v-1h1z",
    fill: "#f3d297"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85h1v1h-1z",
    fill: "#f6d59e"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M57 85v1h-1v-1z",
    fill: "#fbddb4"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#fde1bd"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M58 85h1v1h-1z",
    fill: "#ffe3c4"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M62 86h-1v-1h1z",
    fill: "#ffe1c1"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85h1v1h-1z",
    fill: "#fcddb4"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v1h-1v-1z",
    fill: "#fad9ab"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M66 86h-1v-1h1z",
    fill: "#fbd6a4"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v1h-1v-1z",
    fill: "#fbd39f"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85h1v1h-1z",
    fill: "#f0c998",
    fillOpacity: 0.973
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v1h-1v-1z",
    fill: "#c9a17f",
    fillOpacity: 0.149
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87h-1v-1h1z",
    fill: "#e3735a",
    fillOpacity: 0.651
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87v-1h1v1z",
    fill: "#ff885b"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M21 86v1h-1v-1z",
    fill: "#fdab84"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M22 87h-1v-1h1z",
    fill: "#ffdcb8"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M25 86v1h-1v-1z",
    fill: "#fee9bb"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87v-1h1v1z",
    fill: "#fdeecc"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h1v1h-1z",
    fill: "#feedca"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M29 87h-1v-1h1z",
    fill: "#fee9c0"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M29 86h1v1h-1z",
    fill: "#fee9be"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87h-1v-1h1z",
    fill: "#fee4b6"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86v1h-1v-1z",
    fill: "#fcd89b"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86h1v1h-1z",
    fill: "#fad48f"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M34 87v-1h1v1z",
    fill: "#fad193"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h1v1h-1z",
    fill: "#f8d08a"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M36 87v-1h1v1z",
    fill: "#f7ce80"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M38 87h-1v-1h1z",
    fill: "#f0c66f"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M39 87h-1v-1h1z",
    fill: "#f4cd80"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v1h-1v-1z",
    fill: "#f9d69c"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86v1h-1v-1z",
    fill: "#fddca9"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#fde6c0"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v-1h1v1z",
    fill: "#fbe0b4"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M44 87v-1h1v1z",
    fill: "#f5d49d"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v-1h1v1z",
    fill: "#f0cb85"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v1z",
    fill: "#ecc577"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86v1h-1v-1z",
    fill: "#ebc57b"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M49 86v1h-1v-1z",
    fill: "#e8c26f"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87h-1v-1h1z",
    fill: "#e9c36c"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M50 86h1v1h-1z",
    fill: "#e8c267"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h1v1h-1z",
    fill: "#edc672"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86h1v1h-1z",
    fill: "#f2ce8a"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86v1h-1v-1z",
    fill: "#f2d08c"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M55 86v1h-1v-1z",
    fill: "#f5d18f"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87v-1h1v1z",
    fill: "#f8d49a"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87h-1v-1h1z",
    fill: "#fbd8a4"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86v1h-1v-1z",
    fill: "#fddbab"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86h1v1h-1z",
    fill: "#fedfb7"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87v-1h1v1z",
    fill: "#fde0b8"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M60 87v-1h1v1z",
    fill: "#fce0b7"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M62 87h-1v-1h1z",
    fill: "#fde2be"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#fcdaad"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v1h-1v-1z",
    fill: "#fbd8ab"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M68 86v1h-1v-1z",
    fill: "#f6c487"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M68 87v-1h1v1z",
    fill: "#e8ab81",
    fillOpacity: 0.263
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87v1h-1v-1z",
    fill: "#e8784d",
    fillOpacity: 0.714
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87h1v1h-1z",
    fill: "#fb985f"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M20 87h1v1h-1z",
    fill: "#fdcb9f"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M22 87h1v1h-1z",
    fill: "#fee7ba"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M24 87v1h-1v-1z",
    fill: "#ffe9c2"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M25 88h-1v-1h1z",
    fill: "#fee8bc"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M25 87h1v1h-1z",
    fill: "#ffe9be"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88h-1v-1h1z",
    fill: "#fee9c4"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M27 87h1v1h-1z",
    fill: "#ffe9c1"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88v-1h1v1z",
    fill: "#fee6be"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M30 88h-1v-1h1z",
    fill: "#feeac2"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M31 88h-1v-1h1z",
    fill: "#fde4b4"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M32 88h-1v-1h1z",
    fill: "#fde0b1"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88h-1v-1h1z",
    fill: "#fcd79d"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88v-1h1v1z",
    fill: "#fad28f"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88h-1v-1h1z",
    fill: "#f9d28f"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v-1h1v1z",
    fill: "#f9d38f"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M36 88v-1h1v1z",
    fill: "#f6d18e"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M37 87h1v1h-1z",
    fill: "#f6d496"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88v-1h1v1z",
    fill: "#f8d7a1"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M40 88h-1v-1h1z",
    fill: "#fcdba9"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v1h-1v-1z",
    fill: "#fdddad"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v1h-1v-1z",
    fill: "#fee6c3"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M43 88v-1h1v1z",
    fill: "#faddb0"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v1h-1v-1z",
    fill: "#f5d2a0"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-1h1v1z",
    fill: "#f6d095"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h-1v-1h1z",
    fill: "#f2cd8c"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88h-1v-1h1z",
    fill: "#f0c985"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M49 88h-1v-1h1z",
    fill: "#e9c475"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87v1h-1v-1z",
    fill: "#e7c36a"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88v-1h1v1z",
    fill: "#e9c56b"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M51 87h1v1h-1z",
    fill: "#eec774"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M53 87v1h-1v-1z",
    fill: "#f5d190"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88h-1v-1h1z",
    fill: "#f2ce81"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87v1h-1v-1z",
    fill: "#f9d496"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M57 88v-1h1v1z",
    fill: "#fad59a"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88h-1v-1h1z",
    fill: "#fcd9a5"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87h1v1h-1z",
    fill: "#fddbaf"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87h1v1h-1z",
    fill: "#fddfb8"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M62 88v-1h1v1z",
    fill: "#fde1c0"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M64 87v1h-1v-1z",
    fill: "#fdddb8"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M64 88v-1h1v1z",
    fill: "#fcd7ac"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v-1h1v1z",
    fill: "#f9d5a6"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87v1h-1v-1z",
    fill: "#fbd5a6"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h1v1h-1z",
    fill: "#ffd6a5"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87v1h-1v-1z",
    fill: "#f4d0a9",
    fillOpacity: 0.384
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M18 88v1h-1v-1z",
    fill: "#bf7f6a",
    fillOpacity: 0.047
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M18 89v-1h1v1z",
    fill: "#efa075",
    fillOpacity: 0.859
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M20 88v1h-1v-1z",
    fill: "#fdc092"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M20 88h1v1h-1z",
    fill: "#fed9ae"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M21 89v-1h1v1z",
    fill: "#fde4ba"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M24 89h-1v-1h1z",
    fill: "#ffeac4"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M25 89h-1v-1h1z",
    fill: "#fee8bd"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M26 89h-1v-1h1z",
    fill: "#ffe7bd"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88v1h-1v-1z",
    fill: "#ffe6bf"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88h1v1h-1z",
    fill: "#fde9c8"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M30 88v1h-1v-1z",
    fill: "#fee5bd"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M30 89v-1h1v1z",
    fill: "#fedfaf"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v-1h1v1z",
    fill: "#fedfb0"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M32 89v-1h1v1z",
    fill: "#fcd89e"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v1h-1v-1z",
    fill: "#fdd69d"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89h-1v-1h1z",
    fill: "#fbd69f"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v-1h1v1z",
    fill: "#f9d6a3"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v-1h1v1z",
    fill: "#fbdbad"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88v1h-1v-1z",
    fill: "#fcdeb2"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88h1v1h-1z",
    fill: "#fcddb0"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h-1v-1h1z",
    fill: "#fddeb0"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#ffe5c2"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88v1h-1v-1z",
    fill: "#faddb1"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M45 89h-1v-1h1z",
    fill: "#fad7a6"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88h1v1h-1z",
    fill: "#f7d29b"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88v1h-1v-1z",
    fill: "#f1ca8b"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v-1h1v1z",
    fill: "#ebc679"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89v-1h1v1z",
    fill: "#e9c471"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88v1h-1v-1z",
    fill: "#edc77b"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h-1v-1h1z",
    fill: "#f3ce8e"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v-1h1v1z",
    fill: "#f4d498"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89h-1v-1h1z",
    fill: "#f4d291"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89v-1h1v1z",
    fill: "#f5d292"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89h-1v-1h1z",
    fill: "#f8d398"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88v1h-1v-1z",
    fill: "#fad5a0"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v-1h1v1z",
    fill: "#fcd4a4"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v-1h1v1z",
    fill: "#fdd6a9"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M62 89h-1v-1h1z",
    fill: "#fcd9b0"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M63 89h-1v-1h1z",
    fill: "#fcdcb5"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M63 88h1v1h-1z",
    fill: "#fdddb9"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v1h-1v-1z",
    fill: "#fbd6a9"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M66 88v1h-1v-1z",
    fill: "#f6d09f"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M67 89h-1v-1h1z",
    fill: "#f7cfa0"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M68 88v1h-1v-1z",
    fill: "#fbc998"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M69 89h-1v-1h1z",
    fill: "#e2977e",
    fillOpacity: 0.698
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h-1v-1h1z",
    fill: "#da91b6",
    fillOpacity: 0.027
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M17 90v-1h1v1z",
    fill: "#e8b390",
    fillOpacity: 0.318
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M19 89v1h-1v-1z",
    fill: "#fdcda8"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M19 90v-1h1v1z",
    fill: "#feddb8"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M21 89v1h-1v-1z",
    fill: "#fee5bc"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M22 90v-1h1v1z",
    fill: "#fee8c4"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90v-1h1v1z",
    fill: "#ffe3b7"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M26 89v1h-1v-1z",
    fill: "#fee2b5"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M28 90h-1v-1h1z",
    fill: "#ffe5c0"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M29 89v1h-1v-1z",
    fill: "#ffe3b9"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v1h-1v-1z",
    fill: "#feda9f"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89h1v1h-1z",
    fill: "#feddaa"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M34 90h-1v-1h1z",
    fill: "#fdd9a3"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M34 89h1v1h-1z",
    fill: "#fddaa7"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v1h-1v-1z",
    fill: "#fcd7a4"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v1h-1v-1z",
    fill: "#fcd6a3"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90h-1v-1h1z",
    fill: "#fbd8a6"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M40 89v1h-1v-1z",
    fill: "#fcdba7"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h1v1h-1z",
    fill: "#fde0b9"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M43 90h-1v-1h1z",
    fill: "#fee4c1"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1z",
    fill: "#fcdcb0"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h-1v-1h1z",
    fill: "#f9d7a6"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M46 89v1h-1v-1z",
    fill: "#f5d296"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v1h-1v-1z",
    fill: "#edc67f"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M48 90v-1h1v1z",
    fill: "#efc882"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89h1v1h-1z",
    fill: "#f2cb85"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M50 89h1v1h-1z",
    fill: "#f3cf8d"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M52 90h-1v-1h1z",
    fill: "#f2ce8d"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v1h-1v-1z",
    fill: "#f3d191"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h1v1h-1z",
    fill: "#f4d097"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89v1h-1v-1z",
    fill: "#f5d29a"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M55 90v-1h1v1z",
    fill: "#f9d6ab"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h1v1h-1z",
    fill: "#f8d7ab"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89v1h-1v-1z",
    fill: "#f7d7a7"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v1h-1v-1z",
    fill: "#f9d8aa"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v1h-1v-1z",
    fill: "#fad9ac"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90v-1h1v1z",
    fill: "#fad9ae"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M61 89h1v1h-1z",
    fill: "#fbdbb5"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h1z",
    fill: "#fddab4"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v-1h1v1z",
    fill: "#fad7a8"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89v1h-1v-1z",
    fill: "#facfa0"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89h1v1h-1z",
    fill: "#f2b881"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90v-1h1v1z",
    fill: "#e48c50"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h-1v-1h1z",
    fill: "#c75049",
    fillOpacity: 0.929
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v-1h1v1z",
    fill: "#d096ad",
    fillOpacity: 0.086
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M16 91v-1h1v1z",
    fill: "#7f7f7f",
    fillOpacity: 0.008
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M18 90v1h-1v-1z",
    fill: "#f5c1a2",
    fillOpacity: 0.702
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M18 91v-1h1v1z",
    fill: "#ffdeb7"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91h-1v-1h1z",
    fill: "#fddeba"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M21 90v1h-1v-1z",
    fill: "#ffe1bc"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M21 91v-1h1v1z",
    fill: "#ffe4c6"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M23 91v-1h1v1z",
    fill: "#fee0ac"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90h1v1h-1z",
    fill: "#fedfad"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M25 90h1v1h-1z",
    fill: "#ffe0b4"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90h1v1h-1z",
    fill: "#ffe3bb"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91v-1h1v1z",
    fill: "#ffe1b6"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91v-1h1v1z",
    fill: "#fddba7"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M30 90v1h-1v-1z",
    fill: "#fcd89c"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91v-1h1v1z",
    fill: "#fcd89a"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M35 90v1h-1v-1z",
    fill: "#fad9a6"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M36 90v1h-1v-1z",
    fill: "#fcd7a1"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90v1h-1v-1z",
    fill: "#fdd7a2"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90v1h-1v-1z",
    fill: "#fbd9a1"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M38 91v-1h1v1z",
    fill: "#fbda9e"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M39 90h1v1h-1z",
    fill: "#fcdca9"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#fcddb3"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v-1h1v1z",
    fill: "#fbd7a3"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90h1v1h-1z",
    fill: "#f7d4a0"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h1v1h-1z",
    fill: "#f4d193"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1z",
    fill: "#f1ca86"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91h-1v-1h1z",
    fill: "#f1cc89"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M49 90v1h-1v-1z",
    fill: "#f4cf93"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v-1h1v1z",
    fill: "#f5d093"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M50 91v-1h1v1z",
    fill: "#f5d197"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v1z",
    fill: "#f5d29e"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#f5d4a1"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90v1h-1v-1z",
    fill: "#f7d4a5"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90h1v1h-1z",
    fill: "#f8d6a6"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#fad8b0"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91h-1v-1h1z",
    fill: "#f9d9b3"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v-1h1v1z",
    fill: "#fbdcb7"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M59 90h1v1h-1z",
    fill: "#fcdeb7"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90h1v1h-1z",
    fill: "#fcdfba"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M62 90v1h-1v-1z",
    fill: "#fcdebd"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v1h-1v-1z",
    fill: "#feddbd"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M64 91h-1v-1h1z",
    fill: "#fcd7ab"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91h-1v-1h1z",
    fill: "#f8d0a1"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v-1h1v1z",
    fill: "#fccd99"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M66 90h1v1h-1z",
    fill: "#de8d51"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90h1v1h-1z",
    fill: "#d25e31"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v1h-1v-1z",
    fill: "#c9605b",
    fillOpacity: 0.784
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M16 91h1v1h-1z",
    fill: "#daa3a3",
    fillOpacity: 0.055
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M17 92v-1h1v1z",
    fill: "#eaa787",
    fillOpacity: 0.898
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M19 92h-1v-1h1z",
    fill: "#fed1a6"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91v1h-1v-1z",
    fill: "#fcd9ac"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91h1v1h-1z",
    fill: "#fedeb6"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M21 91h1v1h-1z",
    fill: "#fee1be"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M23 91v1h-1v-1z",
    fill: "#fddeb3"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v-1h1v1z",
    fill: "#fedeb1"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91h1v1h-1z",
    fill: "#feddb1"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M29 92v-1h1v1z",
    fill: "#fdd9a5"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91h1v1h-1z",
    fill: "#fdd9a6"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M31 92v-1h1v1z",
    fill: "#fdd8a4"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91h1v1h-1z",
    fill: "#ffdaa9"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M33 91h1v1h-1z",
    fill: "#ffdbac"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M34 92v-1h1v1z",
    fill: "#fcd9a6"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M36 92h-1v-1h1z",
    fill: "#fbd9a4"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M39 92h-1v-1h1z",
    fill: "#fddeac"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M39 91h1v1h-1z",
    fill: "#ffe2ba"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91h1v1h-1z",
    fill: "#fee6c1"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1z",
    fill: "#fde0b7"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#fad49f"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92h-1v-1h1z",
    fill: "#f7ce8d"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92v-1h1v1z",
    fill: "#f6cf92"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M45 91h1v1h-1z",
    fill: "#f4cd8f"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1z",
    fill: "#f3cb8b"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91v1h-1v-1z",
    fill: "#f6cf95"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92h-1v-1h1z",
    fill: "#f8d29e"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M51 92h-1v-1h1z",
    fill: "#f5d299"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#f8d4a5"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#f4d3a2"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M55 91v1h-1v-1z",
    fill: "#f5d6a5"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-1z",
    fill: "#f8d8a9"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1z",
    fill: "#f7d6aa"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92v-1h1v1z",
    fill: "#fadab2"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91v1h-1v-1z",
    fill: "#f9dab5"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h1v1h-1z",
    fill: "#fbd9af"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v-1h1v1z",
    fill: "#fdd9b1"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92h-1v-1h1z",
    fill: "#fdd9b5"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92v-1h1v1z",
    fill: "#f9d5aa"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v1h-1v-1z",
    fill: "#f8cd9f"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M66 91v1h-1v-1z",
    fill: "#f8c692"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92h-1v-1h1z",
    fill: "#e8965e"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M67 91h1v1h-1z",
    fill: "#d46855"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h-1v-1h1z",
    fill: "#c87268",
    fillOpacity: 0.42
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M18 93h-1v-1h1z",
    fill: "#e28d7e",
    fillOpacity: 0.69
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M19 92v1h-1v-1z",
    fill: "#fcb37b"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M19 93v-1h1v1z",
    fill: "#fcd5a1"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h-1v-1h1z",
    fill: "#ffd7a7"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v1h-1v-1z",
    fill: "#fed6a3"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92h1v1h-1z",
    fill: "#fed9a6"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M26 92h1v1h-1z",
    fill: "#fedcb0"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h1v1h-1z",
    fill: "#fedbb1"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M28 93v-1h1v1z",
    fill: "#fedcae"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M30 92h1v1h-1z",
    fill: "#fedbaa"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h-1v-1h1z",
    fill: "#ffdba7"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h-1v-1h1z",
    fill: "#fedaa6"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93v-1h1v1z",
    fill: "#fedba9"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M35 92v1h-1v-1z",
    fill: "#ffe0b0"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93v-1h1v1z",
    fill: "#fee1b1"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M36 93v-1h1v1z",
    fill: "#fee0b0"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M37 92h1v1h-1z",
    fill: "#fde0b2"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M40 92v1h-1v-1z",
    fill: "#ffe6c6"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M40 93v-1h1v1z",
    fill: "#fee3c1"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#fcd9aa"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93v-1h1v1z",
    fill: "#f3c87a"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92v1h-1v-1z",
    fill: "#efc676"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#efc87b"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#f1c887"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93h-1v-1h1z",
    fill: "#f6d098"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92v1h-1v-1z",
    fill: "#f8d198"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1z",
    fill: "#f5cf90"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#f7d196"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M52 92h1v1h-1z",
    fill: "#f9d39c"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#f7d3a2"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M55 93h-1v-1h1z",
    fill: "#f5d3a4"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M56 93h-1v-1h1z",
    fill: "#f8d7ac"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92h1v1h-1z",
    fill: "#f9d9b1"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93h-1v-1h1z",
    fill: "#f3d2a4"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92h1v1h-1z",
    fill: "#f5d1a5"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M59 92h1v1h-1z",
    fill: "#f7d5af"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v1h-1v-1z",
    fill: "#fad4a8"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h-1v-1h1z",
    fill: "#fad3a7"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93v-1h1v1z",
    fill: "#fbd5ae"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M64 92v1h-1v-1z",
    fill: "#f9d2a8"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93h-1v-1h1z",
    fill: "#f8c899"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M65 92h1v1h-1z",
    fill: "#f0b470"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M66 92h1v1h-1z",
    fill: "#db8145"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M67 93v-1h1v1z",
    fill: "#d07b7b",
    fillOpacity: 0.898
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92v1h-1v-1z",
    fill: "#d29696",
    fillOpacity: 0.067
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M17 93h1v1h-1z",
    fill: "#dca5a5",
    fillOpacity: 0.2
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M19 94h-1v-1h1z",
    fill: "#e79978",
    fillOpacity: 0.961
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93v1h-1v-1z",
    fill: "#fcbe88"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93h1v1h-1z",
    fill: "#fdd5a3"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M21 94v-1h1v1z",
    fill: "#fcd6ab"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M22 94v-1h1v1z",
    fill: "#fcd5a3"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94h-1v-1h1z",
    fill: "#fcd39d"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h1v1h-1z",
    fill: "#fed295"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M25 93h1v1h-1z",
    fill: "#fcd293"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93v1h-1v-1z",
    fill: "#fed5a3"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93h1v1h-1z",
    fill: "#fedaae"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M28 94v-1h1v1z",
    fill: "#fdddae"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M30 93v1h-1v-1z",
    fill: "#fdddac"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93v1h-1v-1z",
    fill: "#fedca7"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h1v1h-1z",
    fill: "#fee2b3"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93h1v1h-1z",
    fill: "#fee1b8"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v-1h1v1z",
    fill: "#fee0b7"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93v1h-1v-1z",
    fill: "#fde1b9"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93h1v1h-1z",
    fill: "#fde6c7"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94h-1v-1h1z",
    fill: "#fedfba"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94v-1h1v1z",
    fill: "#fbd496"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94v-1h1v1z",
    fill: "#f5ca7f"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h1v1h-1z",
    fill: "#f6c985"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M45 94h-1v-1h1z",
    fill: "#f2c779"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h-1v-1h1z",
    fill: "#eec676"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-1v-1z",
    fill: "#f3ca8b"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94h-1v-1h1z",
    fill: "#f2ca8c"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93v1h-1v-1z",
    fill: "#f6ce94"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#f9d195"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93v1h-1v-1z",
    fill: "#f9cf90"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93v1h-1v-1z",
    fill: "#f8d093"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h1v1h-1z",
    fill: "#fad39d"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94h-1v-1h1z",
    fill: "#fad19e"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#f4d29c"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94v-1h1v1z",
    fill: "#fcdab2"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93v1h-1v-1z",
    fill: "#f9d6b0"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M59 93v1h-1v-1z",
    fill: "#f6cfa5"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94h-1v-1h1z",
    fill: "#f7d1ab"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93h1v1h-1z",
    fill: "#fad3af"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M61 93h1v1h-1z",
    fill: "#f9d1a9"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h1v1h-1z",
    fill: "#f8d0aa"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M64 93v1h-1v-1z",
    fill: "#f9d1a6"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v1h-1v-1z",
    fill: "#f5cda3"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M65 94v-1h1v1z",
    fill: "#efad74"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94h-1v-1h1z",
    fill: "#e18565"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h-1v-1h1z",
    fill: "#d89ea3",
    fillOpacity: 0.604
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M19 94v1h-1v-1z",
    fill: "#df9d98",
    fillOpacity: 0.565
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M20 95h-1v-1h1z",
    fill: "#f29f83"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M21 94v1h-1v-1z",
    fill: "#fcca9a"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95h-1v-1h1z",
    fill: "#fdd3a0"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M22 94h1v1h-1z",
    fill: "#fecd8f"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94v1h-1v-1z",
    fill: "#fdcc85"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M24 95v-1h1v1z",
    fill: "#fbc77c"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M26 94v1h-1v-1z",
    fill: "#faca86"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95v-1h1v1z",
    fill: "#fbce98"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M28 95h-1v-1h1z",
    fill: "#ffd9ab"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M29 94h1v1h-1z",
    fill: "#fee0b4"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94v1h-1v-1z",
    fill: "#fedeaf"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95v-1h1v1z",
    fill: "#fdddaa"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M33 94v1h-1v-1z",
    fill: "#ffe2b5"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M34 94v1h-1v-1z",
    fill: "#fee3bb"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94v1h-1v-1z",
    fill: "#fee0b3"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95v-1h1v1z",
    fill: "#fddcab"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M37 94h1v1h-1z",
    fill: "#fddbb0"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h-1v-1h1z",
    fill: "#fcdfbc"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M39 94h1v1h-1z",
    fill: "#f8d2a9"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v1z",
    fill: "#f9dbac"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95v-1h1v1z",
    fill: "#fcd3a0"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94h1v1h-1z",
    fill: "#f6cb8c"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95h-1v-1h1z",
    fill: "#facc8d"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M44 94h1v1h-1z",
    fill: "#f4c885"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v-1h1v1z",
    fill: "#f7cb8e"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1z",
    fill: "#f6cc95"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95h-1v-1h1z",
    fill: "#f4cd93"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95v-1h1v1z",
    fill: "#f9d09e"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M49 94h1v1h-1z",
    fill: "#f8cf96"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1z",
    fill: "#f7cc8b"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1z",
    fill: "#f5cd89"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M53 94v1h-1v-1z",
    fill: "#f7d099"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#f9d19d"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94v1h-1v-1z",
    fill: "#f9d69f"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h1v1h-1z",
    fill: "#fad3a3"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h1v1h-1z",
    fill: "#f9d7ae"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94v1h-1v-1z",
    fill: "#fbd8b4"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h-1v-1h1z",
    fill: "#f9d8b2"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94v1h-1v-1z",
    fill: "#f7d3ab"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95v-1h1v1z",
    fill: "#fbd1b1"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M61 94h1v1h-1z",
    fill: "#f7cca3"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M63 94v1h-1v-1z",
    fill: "#f3be8b"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M63 95v-1h1v1z",
    fill: "#df8865"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M64 94h1v1h-1z",
    fill: "#ecaf81"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M66 94v1h-1v-1z",
    fill: "#d97e62"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94v1h-1v-1z",
    fill: "#d8979b",
    fillOpacity: 0.957
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M67 95v-1h1v1z",
    fill: "#e2cad0",
    fillOpacity: 0.173
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96v-1h1v1z",
    fill: "#f0d4e2",
    fillOpacity: 0.071
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M19 95h1v1h-1z",
    fill: "#e19998",
    fillOpacity: 0.839
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M21 95v1h-1v-1z",
    fill: "#ee9481"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95v1h-1v-1z",
    fill: "#f2ab7c"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M22 96v-1h1v1z",
    fill: "#eea063"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h-1v-1h1z",
    fill: "#f3ab5d"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M25 96h-1v-1h1z",
    fill: "#f4c069"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96h-1v-1h1z",
    fill: "#fac688"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95h1v1h-1z",
    fill: "#f9cd96"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96v-1h1v1z",
    fill: "#fed9aa"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96v-1h1v1z",
    fill: "#fddfb3"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M30 95v1h-1v-1z",
    fill: "#fde1b6"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96h-1v-1h1z",
    fill: "#ffdfb5"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95h1v1h-1z",
    fill: "#fedcaf"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M32 96v-1h1v1z",
    fill: "#fcdbab"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96h-1v-1h1z",
    fill: "#fcdaaa"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M35 95v1h-1v-1z",
    fill: "#fcd8a0"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h-1v-1h1z",
    fill: "#fed8a0"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95h1v1h-1z",
    fill: "#fedaac"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M38 95v1h-1v-1z",
    fill: "#fbdcaf"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M38 96v-1h1v1z",
    fill: "#f5a67e"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h1v1h-1z",
    fill: "#ea4c33"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h-1v-1h1z",
    fill: "#ee7550"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95h1v1h-1z",
    fill: "#fac593"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M43 96h-1v-1h1z",
    fill: "#fcd0a0"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95v1h-1v-1z",
    fill: "#f9ca95"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v1h-1v-1z",
    fill: "#f9cc9a"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#f8ce99"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v-1h1v1z",
    fill: "#f8cd98"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M50 95v1h-1v-1z",
    fill: "#f7cd92"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v1h-1v-1z",
    fill: "#f5ca89"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h1v1h-1z",
    fill: "#f8ca86"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h-1v-1h1z",
    fill: "#f7d095"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95v1h-1v-1z",
    fill: "#f7c78f"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95h1v1h-1z",
    fill: "#efa175"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96h-1v-1h1z",
    fill: "#f8d4a3"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96v-1h1v1z",
    fill: "#f7d1a5"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M57 95h1v1h-1z",
    fill: "#f8cea3"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h1v1h-1z",
    fill: "#f7cfab"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h1v1h-1z",
    fill: "#f7cca8"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h-1v-1h1z",
    fill: "#f4c89a"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95v1h-1v-1z",
    fill: "#ecab73"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95h1v1h-1z",
    fill: "#cf6444"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h-1v-1h1z",
    fill: "#c84540"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96h-1v-1h1z",
    fill: "#d36a54"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h-1v-1h1z",
    fill: "#dc8d8f"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96v-1h1v1z",
    fill: "#ddb3ba",
    fillOpacity: 0.541
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M19 96h1v1h-1z",
    fill: "#e1b4b7",
    fillOpacity: 0.267
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M20 97v-1h1v1z",
    fill: "#e19090",
    fillOpacity: 0.98
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M21 96h1v1h-1z",
    fill: "#e48380"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M23 96v1h-1v-1z",
    fill: "#dc6461"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96v1h-1v-1z",
    fill: "#d54f3a"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h1v1h-1z",
    fill: "#f4a565"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96v1h-1v-1z",
    fill: "#f7c288"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M26 97v-1h1v1z",
    fill: "#fbd1a0"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96h1v1h-1z",
    fill: "#feddb5"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96h1v1h-1z",
    fill: "#fddeb8"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97v-1h1v1z",
    fill: "#fcd6a6"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M32 97v-1h1v1z",
    fill: "#fcd5a0"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M34 97v-1h1v1z",
    fill: "#fcd89d"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96v1h-1v-1z",
    fill: "#ffd6a1"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h1v1h-1z",
    fill: "#fac393"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97h-1v-1h1z",
    fill: "#f28d6a"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M39 97h-1v-1h1z",
    fill: "#eb432e"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M39 96h1v1h-1z",
    fill: "#e83120"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96v1h-1v-1z",
    fill: "#e24125"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h1v1h-1z",
    fill: "#e25434"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97v-1h1v1z",
    fill: "#ef8e62"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97v-1h1v1z",
    fill: "#f5b976"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97h-1v-1h1z",
    fill: "#f5c180"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M46 96v1h-1v-1z",
    fill: "#f5c587"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v1h-1v-1z",
    fill: "#f4c586"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v1h-1v-1z",
    fill: "#f4c687"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97v-1h1v1z",
    fill: "#f4c481"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97v-1h1v1z",
    fill: "#f7c687"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M51 96v1h-1v-1z",
    fill: "#f7c688"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M52 97h-1v-1h1z",
    fill: "#f5ca8d"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96v1h-1v-1z",
    fill: "#fac989"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M54 96v1h-1v-1z",
    fill: "#ea7947"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M55 96v1h-1v-1z",
    fill: "#d91f0b"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97v-1h1v1z",
    fill: "#e68058"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M57 96v1h-1v-1z",
    fill: "#f6c28b"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M58 96v1h-1v-1z",
    fill: "#f6c692"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M58 97v-1h1v1z",
    fill: "#f1c08a"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96v1h-1v-1z",
    fill: "#ecac71"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M60 97v-1h1v1z",
    fill: "#d97b54"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h1v1h-1z",
    fill: "#c34d40"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M63 96v1h-1v-1z",
    fill: "#b3373d"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M63 97v-1h1v1z",
    fill: "#bf4f55"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96v1h-1v-1z",
    fill: "#d3787e"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M65 97v-1h1v1z",
    fill: "#d6a0a5",
    fillOpacity: 0.749
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#d0b9b9",
    fillOpacity: 0.043
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M20 97h1v1h-1z",
    fill: "#dd9e9e",
    fillOpacity: 0.51
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M21 97h1v1h-1z",
    fill: "#df8586"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M22 97h1v1h-1z",
    fill: "#de7d7b"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97v1h-1v-1z",
    fill: "#d45758"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97h1v1h-1z",
    fill: "#dc6f51"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M26 97v1h-1v-1z",
    fill: "#f8b57d"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98h-1v-1h1z",
    fill: "#fbd2a8"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M28 98h-1v-1h1z",
    fill: "#fcdab5"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v1h-1v-1z",
    fill: "#fedab0"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97h1v1h-1z",
    fill: "#fcd7a8"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97h1v1h-1z",
    fill: "#fad7a1"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M33 97v1h-1v-1z",
    fill: "#fed7a4"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98h-1v-1h1z",
    fill: "#fbd4a1"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M35 97v1h-1v-1z",
    fill: "#ed946e"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v-1h1v1z",
    fill: "#ea6749"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M36 98v-1h1v1z",
    fill: "#e1462f"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97v1h-1v-1z",
    fill: "#e2392a"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M38 98v-1h1v1z",
    fill: "#dc3327"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98v-1h1v1z",
    fill: "#d63125"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v-1h1v1z",
    fill: "#d22e1f"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M41 98v-1h1v1z",
    fill: "#ce2d21"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97h1v1h-1z",
    fill: "#d33b1f"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97h1v1h-1z",
    fill: "#d44e20"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97v1h-1v-1z",
    fill: "#dc6b30"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M46 98h-1v-1h1z",
    fill: "#e78b4a"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97v1h-1v-1z",
    fill: "#ea9d58"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h-1v-1h1z",
    fill: "#edab5f"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97h1v1h-1z",
    fill: "#efb264"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97h1v1h-1z",
    fill: "#f2b76e"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M50 97h1v1h-1z",
    fill: "#f5b470"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v-1h1v1z",
    fill: "#eda45f"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97v1h-1v-1z",
    fill: "#e06a37"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97h1v1h-1z",
    fill: "#d72d0d"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M54 97h1v1h-1z",
    fill: "#cf2211"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97h1v1h-1z",
    fill: "#cc1c0e"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M57 97v1h-1v-1z",
    fill: "#de7044"
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h-1v-1h1z",
    fill: "#eeaa62"
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M59 97v1h-1v-1z",
    fill: "#da8148"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98h-1v-1h1z",
    fill: "#bc4128"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M61 98h-1v-1h1z",
    fill: "#b33232"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M62 97v1h-1v-1z",
    fill: "#ad3a42"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98h-1v-1h1z",
    fill: "#b44b51"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v-1h1v1z",
    fill: "#c9696e"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98h-1v-1h1z",
    fill: "#cb8589",
    fillOpacity: 0.792
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97v1h-1v-1z",
    fill: "#c89aa3",
    fillOpacity: 0.11
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M22 98v1h-1v-1z",
    fill: "#d88d8b",
    fillOpacity: 0.667
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M22 99v-1h1v1z",
    fill: "#de7f7e"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M24 99h-1v-1h1z",
    fill: "#d3716f"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99h-1v-1h1z",
    fill: "#d25a59"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99v-1h1v1z",
    fill: "#de7554"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98v1h-1v-1z",
    fill: "#f9bb8a"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98h1v1h-1z",
    fill: "#fdd3aa"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M29 99h-1v-1h1z",
    fill: "#fad09f"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M30 98v1h-1v-1z",
    fill: "#fcd096"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M31 99h-1v-1h1z",
    fill: "#facd90"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M31 98h1v1h-1z",
    fill: "#fdd29e"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M32 98h1v1h-1z",
    fill: "#fed9ac"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98v1h-1v-1z",
    fill: "#fac694"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v1h-1v-1z",
    fill: "#e04930"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h-1v-1h1z",
    fill: "#da2f23"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h-1v-1h1z",
    fill: "#d8312a"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M38 99h-1v-1h1z",
    fill: "#cd2922"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h-1v-1h1z",
    fill: "#c72922"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v1h-1v-1z",
    fill: "#c22924"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98h1v1h-1z",
    fill: "#c02820"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v-1h1v1z",
    fill: "#bc2a1d"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99v-1h1v1z",
    fill: "#ca3d22"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M43 99v-1h1v1z",
    fill: "#c12715"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M44 99v-1h1v1z",
    fill: "#c72717"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M45 98h1v1h-1z",
    fill: "#c92e14"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M46 99v-1h1v1z",
    fill: "#cb381a"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v1h-1v-1z",
    fill: "#cc3718"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v1h-1z",
    fill: "#cf441c"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99h-1v-1h1z",
    fill: "#cb461a"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v1h-1v-1z",
    fill: "#c83815"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M51 99v-1h1v1z",
    fill: "#c0240c"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99h-1v-1h1z",
    fill: "#b9180e"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99h-1v-1h1z",
    fill: "#b51912"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99v-1h1v1z",
    fill: "#b01710"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v-1h1v1z",
    fill: "#b11710"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99v-1h1v1z",
    fill: "#b51f16"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99h-1v-1h1z",
    fill: "#b42d1a"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h1v1h-1z",
    fill: "#a91b1b"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M59 99v-1h1v1z",
    fill: "#a8282f"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v-1h1v1z",
    fill: "#ae4045"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99v-1h1v1z",
    fill: "#b24d50"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v1h-1v-1z",
    fill: "#be6368"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M64 99h-1v-1h1z",
    fill: "#bb7376",
    fillOpacity: 0.682
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98v1h-1v-1z",
    fill: "#b17979",
    fillOpacity: 0.09
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M21 100v-1h1v1z",
    fill: "#e2aaaa",
    fillOpacity: 0.071
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M22 99h1v1h-1z",
    fill: "#d68a85",
    fillOpacity: 0.757
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100h-1v-1h1z",
    fill: "#dd7e7d"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100v-1h1v1z",
    fill: "#cf6865"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99h1v1h-1z",
    fill: "#cb5856"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100h-1v-1h1z",
    fill: "#dd7858"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100v-1h1v1z",
    fill: "#f5b47e"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M28 100v-1h1v1z",
    fill: "#fbc997"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100h-1v-1h1z",
    fill: "#fece9d"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100v-1h1v1z",
    fill: "#fccf96"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M32 100h-1v-1h1z",
    fill: "#fad29c"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M33 100h-1v-1h1z",
    fill: "#fcd69c"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99v1h-1v-1z",
    fill: "#ee9361"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99h1v1h-1z",
    fill: "#d53828"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99v1h-1v-1z",
    fill: "#ce332c"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h1v1h-1z",
    fill: "#c73023"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h1v1h-1z",
    fill: "#c12e23"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M39 100h-1v-1h1z",
    fill: "#bb2920"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h1v1h-1z",
    fill: "#b72624"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v1h-1v-1z",
    fill: "#b92922"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M41 100v-1h1v1z",
    fill: "#b1231a"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99h1v1h-1z",
    fill: "#b62920"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M44 100h-1v-1h1z",
    fill: "#b62219"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M45 100h-1v-1h1z",
    fill: "#b8221a"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M46 100h-1v-1h1z",
    fill: "#b52119"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M47 100h-1v-1h1z",
    fill: "#b62319"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M48 99v1h-1v-1z",
    fill: "#b61f16"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100v-1h1v1z",
    fill: "#b31c13"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99v1h-1v-1z",
    fill: "#b11813"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100v-1h1v1z",
    fill: "#b11a13"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M52 99v1h-1v-1z",
    fill: "#aa1611"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99v1h-1v-1z",
    fill: "#a41411"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M53 100v-1h1v1z",
    fill: "#9f1112"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v1h-1v-1z",
    fill: "#9c0f12"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M55 100v-1h1v1z",
    fill: "#980f11"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99h1v1h-1z",
    fill: "#960c16"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M57 99h1v1h-1z",
    fill: "#99161f"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M58 100v-1h1v1z",
    fill: "#9a1f27"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v1h-1v-1z",
    fill: "#a93c44"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100v-1h1v1z",
    fill: "#b25355"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99h1v1h-1z",
    fill: "#b05b5b",
    fillOpacity: 0.827
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M63 99v1h-1v-1z",
    fill: "#aa5d62",
    fillOpacity: 0.365
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M63 100v-1h1v1z",
    fillOpacity: 0.008
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M23 101h-1v-1h1z",
    fill: "#e8b1a6",
    fillOpacity: 0.09
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M23 101v-1h1v1z",
    fill: "#d68d84",
    fillOpacity: 0.733
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M25 101h-1v-1h1z",
    fill: "#d77b73"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M25 100h1v1h-1z",
    fill: "#cd6864"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100v1h-1v-1z",
    fill: "#c95d5b"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M27 101v-1h1v1z",
    fill: "#d26252"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M29 101h-1v-1h1z",
    fill: "#da7655"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100v1h-1v-1z",
    fill: "#e6936a"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M31 101h-1v-1h1z",
    fill: "#efaa73"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M31 100h1v1h-1z",
    fill: "#ed9f6b"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101v-1h1v1z",
    fill: "#db6b46"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M33 101v-1h1v1z",
    fill: "#c83a29"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M35 100v1h-1v-1z",
    fill: "#bb2b24"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101h-1v-1h1z",
    fill: "#b32821"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h-1v-1h1z",
    fill: "#b42722"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M38 100v1h-1v-1z",
    fill: "#b62a22"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M38 101v-1h1v1z",
    fill: "#b62724"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M40 100v1h-1v-1z",
    fill: "#af201f"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101h-1v-1h1z",
    fill: "#a8201d"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M42 101h-1v-1h1z",
    fill: "#a41e1a"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M42 100h1v1h-1z",
    fill: "#a7211d"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101h-1v-1h1z",
    fill: "#a51c18"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101v-1h1v1z",
    fill: "#a31b18"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M45 101v-1h1v1z",
    fill: "#a31914"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101v-1h1v1z",
    fill: "#a41813"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101v-1h1v1z",
    fill: "#a71a15"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100h1v1h-1z",
    fill: "#a51814"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M49 101v-1h1v1z",
    fill: "#9f1311"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M51 100v1h-1v-1z",
    fill: "#a31614"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M52 100v1h-1v-1z",
    fill: "#9f1111"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-1v-1h1z",
    fill: "#9e1116"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101h-1v-1h1z",
    fill: "#950c12"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101h-1v-1h1z",
    fill: "#910a12"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M56 100v1h-1v-1z",
    fill: "#920b16"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M56 101v-1h1v1z",
    fill: "#8b0c1b"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M58 101h-1v-1h1z",
    fill: "#941b27"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h-1v-1h1z",
    fill: "#a9383e"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v-1h1v1z",
    fill: "#a94e55",
    fillOpacity: 0.761
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M61 100v1h-1v-1z",
    fill: "#a75a57",
    fillOpacity: 0.322
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101v-1h1v1z",
    fill: "#7f3f3f",
    fillOpacity: 0.047
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M24 101v1h-1v-1z",
    fill: "#e7a2a2",
    fillOpacity: 0.043
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M25 101v1h-1v-1z",
    fill: "#d4847b",
    fillOpacity: 0.565
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102v-1h1v1z",
    fill: "#c66e65",
    fillOpacity: 0.984
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M27 101v1h-1v-1z",
    fill: "#ca6961"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M28 102h-1v-1h1z",
    fill: "#cf6762"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M28 101h1v1h-1z",
    fill: "#c6504f"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M30 101v1h-1v-1z",
    fill: "#b13933"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M31 101v1h-1v-1z",
    fill: "#b43e34"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M31 102v-1h1v1z",
    fill: "#b9392f"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101h1v1h-1z",
    fill: "#b02425"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M34 101v1h-1v-1z",
    fill: "#b22927"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102v-1h1v1z",
    fill: "#b12a27"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101v1h-1v-1z",
    fill: "#a82422"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102v-1h1v1z",
    fill: "#a72221"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h1v1h-1z",
    fill: "#a5201e"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M39 102h-1v-1h1z",
    fill: "#a11c21"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M39 101h1v1h-1z",
    fill: "#a31e22"
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101v1h-1v-1z",
    fill: "#a4201c"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M41 102v-1h1v1z",
    fill: "#a01b1b"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M43 101v1h-1v-1z",
    fill: "#9c1717"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M43 102v-1h1v1z",
    fill: "#9a1815"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102h-1v-1h1z",
    fill: "#9d1a18"
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102h-1v-1h1z",
    fill: "#961110"
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102v-1h1v1z",
    fill: "#9d1713"
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101h1v1h-1z",
    fill: "#991310"
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v-1h1v1z",
    fill: "#991311"
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102h-1v-1h1z",
    fill: "#94110e"
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M50 101h1v1h-1z",
    fill: "#970e0e"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M51 101h1v1h-1z",
    fill: "#9f1217"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101v1h-1v-1z",
    fill: "#920814"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101v1h-1v-1z",
    fill: "#860310"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101v1h-1v-1z",
    fill: "#870511"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M55 102v-1h1v1z",
    fill: "#880916"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102h-1v-1h1z",
    fill: "#8f1420"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M58 102h-1v-1h1z",
    fill: "#993035",
    fillOpacity: 0.988
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v1h-1v-1z",
    fill: "#a44b4b",
    fillOpacity: 0.518
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h1v1h-1z",
    fill: "#9f5f5f",
    fillOpacity: 0.031
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102h1v1h-1z",
    fill: "#bb6e66",
    fillOpacity: 0.235
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M27 103h-1v-1h1z",
    fill: "#b65f5a",
    fillOpacity: 0.553
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M28 103h-1v-1h1z",
    fill: "#b7605c",
    fillOpacity: 0.78
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M29 103h-1v-1h1z",
    fill: "#c06461",
    fillOpacity: 0.914
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M30 102v1h-1v-1z",
    fill: "#b94c4a"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M31 103h-1v-1h1z",
    fill: "#a83336"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M32 102v1h-1v-1z",
    fill: "#a62c2e"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M33 102v1h-1v-1z",
    fill: "#a4272a"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v-1h1v1z",
    fill: "#a22727"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102h1v1h-1z",
    fill: "#a02124"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M35 103v-1h1v1z",
    fill: "#9d2023"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102h1v1h-1z",
    fill: "#9c2023"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M37 102h1v1h-1z",
    fill: "#9c1f21"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M38 103v-1h1v1z",
    fill: "#981a22"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M39 103v-1h1v1z",
    fill: "#96171e"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M40 103v-1h1v1z",
    fill: "#981a1b"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v-1h1v1z",
    fill: "#96171c"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102h1v1h-1z",
    fill: "#931318"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M44 102v1h-1v-1z",
    fill: "#911216"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102v1h-1v-1z",
    fill: "#8c0d12"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h-1v-1h1z",
    fill: "#870710"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M47 103h-1v-1h1z",
    fill: "#94140e"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v1h-1v-1z",
    fill: "#8d0a0c"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M49 102v1h-1v-1z",
    fill: "#88050a"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102v1h-1v-1z",
    fill: "#880909"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M51 103h-1v-1h1z",
    fill: "#8f0b0f"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h-1v-1h1z",
    fill: "#88060c"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M53 103h-1v-1h1z",
    fill: "#810310"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M53 102h1v1h-1z",
    fill: "#810413"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M54 102h1v1h-1z",
    fill: "#830513"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-1v-1h1z",
    fill: "#88121c"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103v-1h1v1z",
    fill: "#8d2a2e",
    fillOpacity: 0.878
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103v-1h1v1z",
    fill: "#964542",
    fillOpacity: 0.333
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M27 103h1v1h-1z",
    fillOpacity: 0.004
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M29 104h-1v-1h1z",
    fill: "#a6584d",
    fillOpacity: 0.09
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M30 104h-1v-1h1z",
    fill: "#bc5f5a",
    fillOpacity: 0.408
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M30 103h1v1h-1z",
    fill: "#af4845",
    fillOpacity: 0.898
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M32 103v1h-1v-1z",
    fill: "#a93738"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v1h-1v-1z",
    fill: "#9e282f"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h-1v-1h1z",
    fill: "#9b262c"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M35 104h-1v-1h1z",
    fill: "#982026"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M35 103h1v1h-1z",
    fill: "#931d21"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M37 103v1h-1v-1z",
    fill: "#901d21"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M37 104v-1h1v1z",
    fill: "#8c1a1e"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h-1v-1h1z",
    fill: "#87171c"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M40 104h-1v-1h1z",
    fill: "#851517"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v1h-1v-1z",
    fill: "#821316"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M42 103v1h-1v-1z",
    fill: "#7e0c14"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M43 104h-1v-1h1z",
    fill: "#790b12"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103v1h-1v-1z",
    fill: "#70070f",
    fillOpacity: 0.976
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103h1v1h-1z",
    fill: "#6e060e",
    fillOpacity: 0.925
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103v1h-1v-1z",
    fill: "#6e040f",
    fillOpacity: 0.898
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h1v1h-1z",
    fill: "#7d1910",
    fillOpacity: 0.906
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M48 103v1h-1v-1z",
    fill: "#770e0f",
    fillOpacity: 0.957
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104h-1v-1h1z",
    fill: "#75050c"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104v-1h1v1z",
    fill: "#780307"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h-1v-1h1z",
    fill: "#80070b"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M52 104h-1v-1h1z",
    fill: "#80060c"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h1v1h-1z",
    fill: "#7e060f"
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103v1h-1v-1z",
    fill: "#840e18"
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104v-1h1v1z",
    fill: "#7e1219",
    fillOpacity: 0.878
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h1v1z",
    fill: "#822125",
    fillOpacity: 0.506
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M56 104v-1h1v1z",
    fill: "#7f3a3a",
    fillOpacity: 0.102
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M31 104v1h-1v-1z",
    fill: "#af5757",
    fillOpacity: 0.125
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105v-1h1v1z",
    fill: "#a54242",
    fillOpacity: 0.573
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M32 105v-1h1v1z",
    fill: "#993435",
    fillOpacity: 0.898
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104v1h-1v-1z",
    fill: "#942b30"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h1v1h-1z",
    fill: "#942429"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M35 105v-1h1v1z",
    fill: "#911e24"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M36 105v-1h1v1z",
    fill: "#8c1922"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M38 105h-1v-1h1z",
    fill: "#83151d"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M38 104h1v1h-1z",
    fill: "#750e16"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h1v1h-1z",
    fill: "#6d0e14"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M41 104v1h-1v-1z",
    fill: "#660b14",
    fillOpacity: 0.859
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105h-1v-1h1z",
    fill: "#5f0a10",
    fillOpacity: 0.6
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105v-1h1v1z",
    fill: "#5b0a12",
    fillOpacity: 0.373
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M43 105v-1h1v1z",
    fill: "#530510",
    fillOpacity: 0.18
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M45 105h-1v-1h1z",
    fill: "#470a0a",
    fillOpacity: 0.098
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M45 104h1v1h-1z",
    fill: "#460e0e",
    fillOpacity: 0.071
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h1v1h-1z",
    fill: "#4c190c",
    fillOpacity: 0.078
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M48 104v1h-1v-1z",
    fill: "#570e0e",
    fillOpacity: 0.137
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M49 105h-1v-1h1z",
    fill: "#610c0c",
    fillOpacity: 0.247
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M50 104v1h-1v-1z",
    fill: "#62090b",
    fillOpacity: 0.427
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105v-1h1v1z",
    fill: "#65060a",
    fillOpacity: 0.643
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h1v1h-1z",
    fill: "#6c0a0f",
    fillOpacity: 0.765
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104v1h-1v-1z",
    fill: "#741015",
    fillOpacity: 0.663
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104h1v1h-1z",
    fill: "#7b191c",
    fillOpacity: 0.388
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M55 105h-1v-1h1z",
    fill: "#722626",
    fillOpacity: 0.078
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M32 106v-1h1v1z",
    fill: "#a24545",
    fillOpacity: 0.086
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106h-1v-1h1z",
    fill: "#913538",
    fillOpacity: 0.337
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h-1v-1h1z",
    fill: "#852b2b",
    fillOpacity: 0.553
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M36 106h-1v-1h1z",
    fill: "#7e2126",
    fillOpacity: 0.682
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h-1v-1h1z",
    fill: "#711821",
    fillOpacity: 0.722
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M38 106h-1v-1h1z",
    fill: "#6b141c",
    fillOpacity: 0.639
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M39 105v1h-1v-1z",
    fill: "#631119",
    fillOpacity: 0.471
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M39 106v-1h1v1z",
    fill: "#5a1114",
    fillOpacity: 0.286
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h-1v-1h1z",
    fill: "#481212",
    fillOpacity: 0.055
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleCore);
export default __webpack_public_path__ + "static/media/apple-core.f3c047472b9ae5c3d7ba600724067d49.svg";
export { ForwardRef as ReactComponent };